/* global SOLVNET */
(function() {
"use strict";
	
var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var shortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
SOLVNET.addLang('en', {
	Locale: 'en',
	LocaleName: 'English',
	LocaleDateFormat: 'MM/DD/YYYY',
	LocaleDateTextFormat: 'MMMM Do YYYY',
	LocaleDateTimeFormat: 'MM/DD/YYYY HH:mm',
	LocaleTimeFormat: 'HH:mm',
	BonjourSimple: 'Hello',
	BonjourComplexe: 'Hello {0}, {1} times',
	days: days,
	shortDays: shortDays,
	months: months,
	shortMonths: shortMonths,
	firstDayOfWeek: 0,

	CKEditorMoreButtonLabel: 'More...',
	HighchartsLang: {
		contextButtonTitle: 'Chart context menu',
		decimalPoint: '.',
		downloadJPEG: 'Save as JPEG',
		downloadPDF: 'Save as PDF',
		downloadPNG: 'Save as PNG',
		downloadSVG: 'Save as SVG',
		drillUpText: 'Back to {series.name}',
		invalidDate: '',
		loading: 'Loading...',
		months: months,
		noData: 'No data to display',
		numericSymbolMagnitude: 1000,
		numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'],
		printChart: 'Print chart',
		resetZoom: 'Reset zoom',
		resetZoomTitle: 'Reset zoom to 100%',
		shortMonths: shortMonths,
		shortWeekdays: shortDays,
		thousandsSep: ',',
		weekdays: days
	},
	ChartTypes: {
		pyramid: 'Pyramid',
		pie: 'Pie',
		donut: 'Donut',
		arc: 'Arc',
		radialBar: 'Radial bars',
		rose: 'Rose',
		radar: 'Radar',
		verticalBar: 'Vertical bars',
		verticalStackedBar: 'Vertical stacked bars',
		verticalLine: 'Vertical lines',
		verticalStackedLine: 'Vertical stacked lines',
		verticalSpline: 'Vertical splines',
		verticalArea: 'Vertical areas',
		verticalStackedArea: 'Vertical stacked areas',
		horizontalBar: 'Horizontal bars',
		horizontalStackedBar: 'Horizontal stacked bars',
		horizontalLine: 'Horizontal lines',
		horizontalStackedLine: 'Horizontal stacked lines',
		horizontalSpline: 'Horizontal splines',
		horizontalArea: 'Horizontal areas',
		horizontalStackedArea: 'Horizontal stacked areas',
		bubble: 'Bubble',
		scatter: 'Scatter',
	},
	DatetimePicker: {
		tooltips: {// Pas besoin car le composant "datetimepicker" définit tout en anglais
			today: 'Today',
			clear: 'Empty selection',
			close: 'Close',
			selectMonth: 'Choose the month',
			prevMonth: 'Previous month',
			nextMonth: 'Next month',
			selectYear: 'Choose the year',
			prevYear: 'Previous year',
			nextYear: 'Next year',
			selectDecade: 'Choose decase',
			prevDecade: 'Previous decade',
			nextDecade: 'Next decade',
			prevCentury: 'Previous century',
			nextCentury: 'Next century',
			pickHour: 'Choose the hour',
			incrementHour: 'Increment hours',
			decrementHour: 'Decrement hours',
			pickMinute: 'Choose the minutes',
			incrementMinute: 'Increment the minutes',
			decrementMinute: 'Decrement the minutes',
			pickSecond: 'Choose the seconds',
			incrementSecond: 'Increment the seconds',
			decrementSecond: 'Decrement the seconds',
			togglePeriod: 'Choose morning or afternoon',
			selectTime: 'Input the time'
		}
	},
	AggregateTypes: {
		Min: 'Min',
		Max: 'Max',
		Sum: 'Sum',
		Count: 'Count',
		Avg: 'Average',
		DistinctSum: 'SumD',
		DistinctCount: 'CountD',
		DistinctAvg: 'AverageD',
		Repeated: 'Unique',
	},
	ListenContextTypes: {
		customerId: 'Customer',
		productId: 'Product'
	},
	FilterFieldGroup: {
		customer: 'Customer',
		product: 'Product'
	},
	FilterMenuButton: 'Filters',
	FilterMenuFastFilters: 'Fast filters',
	FilterMenuAdvancedFilters: 'Advanced filters',
	FilterMenuProductsAdvancedFilters: 'Product advanced filters',
	FilterMenuClearFilters: 'Clear filters',
	FilterFailedToLoad: 'Error while loading filter',

	AdminSaveSettingsSuccessMessage: 'Save completed.',
	AdminSaveSettingsErrorMessage: 'An error occurred. Settings may not be saved',
	AdminImportSuccessMessage: 'Import completed.',
	AdminImportErrorMessage: 'An error occurred. Import failed:',
	AdminImportErrorMessageVersion: 'Unsupported file version: {0}',
	AdminSavePageModelDirtyMessage: 'The page is modified. Please save your changes and try again.',
	AdminLoadPageModelSuccessMessage: 'The page model has been successfully loaded.',
	AdminLoadPageModelConflictMessage: 'Some of the files in this page model already exist.<br />Would you like to replace these files?',
	AdminLoadPageModelBadSectionMessage: 'The current page type "{0}" does not match the page model type "{1}".',
	AdminLoadPageModelErrorMessage: 'An error occured and the page model could not load properly.',
	AdminSectionGeneral: 'Modules',
	AdminSectionPublic: 'Public pages',
	AdminSectionCustomer: 'Customer details',
	AdminSectionProduct: 'Product details',
	AdminSectionOffer: 'Offer details',
	AdminSectionTypology: 'Typology details',
	AdminSectionVisit: 'Visit details',
	AdminSectionOrder: 'Order details',
	AdminSectionReport: 'OLAP report details',
	AdminSectionFeedback: 'Feedback details',
	AdminEditPageAllSelected: 'All',
	AdminEditPageNEntries: ' entries',
	AdminSyncLicencesSuccessMessage: 'Licenses synchronization completed',
	AdminSyncLicencesErrorMessage: 'Licenses synchronization failed',

	AdminBbmDownloadErrorFilename: 'Invalid filename',
	AdminBbmDownloadErrorFileDoesntExist: 'The file does not exist',

	ControlTypeError: 'Unsupported control type {0}',
	ControlRejectedError: 'Evaluation error of control {0} ({1})',
	ControlUnexpectedError: 'Unexpected error of contrôle {0} ({1})',

	InputBooleanYes: 'Yes',
	InputBooleanNo: 'No',
	InputRequired: 'Required',
	InputAttachmentButton: 'Upload file to attachments folder',
	InputAttachmentPhoto: 'Take photo',
	InputAttachmentOverrideMessage: 'The file "{0}" already exists. Do you want to override it with the new file?',

	// A réserver uniquement si on ne connait pas le genre.
	InputMultiSelectNonSelectedText: 'None',
	InputMultiSelectNSelectedText: ' selected fields',
	InputMultiSelectAllSelectedText: 'All',
	InputMultiSelectSelectAllText: 'All / None',
	InputMultiSelectFilterPlaceholder: 'Search...',

	// Libellé multiselect pour les champs
	InputFieldsNonSelectedText: 'None',
	InputFieldsNSelectedText: ' fields',
	InputFieldsAllSelectedText: 'All',
	InputFieldsSelectAllText: 'All / None',
	InputFieldsFilterPlaceholder: 'Search...',

	InputFilterToggle: 'Filters (Yes / No)',

	// Libellé multiselect pour les configurations
	InputConfigurationsNonSelectedText: 'None',
	InputConfigurationsNSelectedText: 'select',
	InputConfigurationsAllSelectedText: 'All',
	InputConfigurationsSelectAllText: 'All / None',
	InputConfigurationsFilterPlaceholder: 'Search...',
	
	// Period types
	InputPeriodTypeFromTo: 'Between',
	InputPeriodTypeNb: 'Less than days ago',
	InputPeriodTypeFrom: 'Since',
	InputPeriodTypeTo: 'Until',
	InputPeriodFromDate : 'Since',
	InputPeriodToDate : 'Until',
	InputPeriodNbDays : 'Number of days',
	
	InputFormInvalidInteger: "'{0}' this is not a valid integer",
	InputFormInvalidDecimal: "'{0}' this is not a valid decimal",
	InputNaNMessage: "'{0}' this is not a number",
	InputProhibitZeroMessage: "'{0}' not accept 0",
	InputGridRequired: "'{0}' is required",
	InputDateRangeError: '{0} is not prior to {1}',
	InputProhibitNegativeValueMessage: "'{0}' not accept negative value",
	InputDateInvalidFormat: 'Invalid date format. Expected format: {0}',
	InputDateNotInRange: 'Date should be included between {0} and {1}',

	CardTypeSelectFailedToLoadList: 'Failed to load: {0}',

	NoResultSearch: 'No result',
	ChangeModelSearch: 'Change model',
	MoreOrLessInformations: 'More / less informations',

	AddToSelectionLabel: 'Add to selection',
	RemoveOfSelectionLabel: 'Remove of selection',

	PublicationNone: 'None',
	PublicationCustom: 'Custom',
	PublicationAll: 'Everyone',

	UserUnknown: 'Unknown',

	LayoutSaveSuccessMessage: 'Save completed.',
	LayoutSaveErrorMessage: 'An error occurred. Page may not be saved',
	LayoutPageDefaultCaption: 'New page',
    LayoutBoxDefaultCaption: 'New box',
	LayoutItemTest: 'Test',
	LayoutItemText: 'Text',
	LayoutItemImage: 'Image',
	LayoutItemURL: 'URL',
	LayoutItemNote: 'Note',
	LayoutItemNoteEdit: 'Edit my note ...',
	LayoutItemExecutable: 'Executable',
	LayoutItemReportGauge: 'Gauge from report',
	LayoutItemReportChart: 'Chart from report',
	LayoutItemReportGrid: 'Report grid',
	LayoutItemReportGridMaximize: 'Maximize report grid',
	LayoutItemReportOLAPSelect: 'Selection list from a report',
	LayoutItemReportOLAPGrid: 'Report OLAP grid',
	LayoutItemReportOLAPGridSaveAs: 'Save as a new report',
	LayoutItemReportOLAPGridSearch: 'Search',
	LayoutItemReportOLAPGridFilters: 'Filters',
	LayoutItemReportOLAPGridCustomization: 'Simple configuration',
	LayoutItemReportOLAPGridConfiguration: 'Advanced configuration',
	LayoutItemReportOLAPGridExport: 'Export report',
	LayoutItemReportOLAPGridMaximize: 'Maximize report',
	LayoutItemReportOLAPGridFilterPageWithMember: 'Filter page on this item',
	LayoutItemReportOLAPGridOpenPageWithMember: 'Details...',
	LayoutItemReportOLAPGridAddToPlanner: 'Add event in calendar',
	LayoutItemReportOLAPGridLoadError: 'An error occurred. Report {0} could not be loaded.',
	LayoutItemReportValuesLevel1Required: 'First level required',
	LayoutItemReportValuesIncorrectGroupValue: 'Incorrect group value (1 or 2)',
	LayoutItemReportValuesInconsistentMeasureGroups: 'Inconsistency between measures and measure groups',
	LayoutItemReportValuesGrid: 'Values from report',
	LayoutItemReportValuesGridReport: 'Report',
	LayoutItemReportValuesGridLevel1: 'First level',
	LayoutItemReportValuesGridLevel2: 'Second level',
	LayoutItemReportValuesGridLevel1Axis: 'First level axis',
	LayoutItemReportValuesGridLevel1AxisInLine: 'In line',
	LayoutItemReportValuesGridLevel1AxisInColumn: 'In column',
	LayoutItemReportValuesGridMeasures: 'Measures',
	LayoutItemReportValuesGridMeasureGroups: 'Measures groups',
	LayoutItemReportValuesGridMeasureColors: 'Measures colors',
	LayoutItemReportValuesGridShowGroupArrow: 'Show up/down group arrows',
	LayoutItemReportValuesGridLevelFilters: 'Auto-filter on context',
	LayoutItemReportValuesGridShowIntermediateTotals: 'Display intermediate totals',
	LayoutItemReportValuesGridShowGrandTotals: 'Display grand totals',
	LayoutItemReportValuesGridMaximize: 'Maximize values from report grid',
	LayoutItemReportValuesGridTotals: 'Totals',
	LayoutItemReportValuesGridGrandTotals: 'Totals',
	LayoutItemReportMap: 'Report map',
	LayoutItemReportMapReport: 'Report',
	LayoutItemReportMapMeasures: 'Measures',
	LayoutItemReportMapMeasuresHelp: 'Measures shown in popover when a customer is selected',
	LayoutItemReportMapHighlightMeasure: 'Colors',
	LayoutItemReportMapHighlightMeasureHelp: 'Measure used to color customers depending on it\'s value',
	LayoutItemReportMapNotFound: 'No data for this customer',
	LayoutItemCustomerGrid: 'Customer grid',
	LayoutItemCustomerForm: 'Customer form',
	LayoutItemCustomerImage: 'Customer image',
	LayoutItemCustomerGridMassDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>ALL</u></b> displayed customers tagged "to remove".<br>Do you want to continue deleting?',
	LayoutItemContactGrid: 'Customer contact grid',
	LayoutItemContactForm: 'Customer contact form',
	LayoutItemMap: 'Map',
	LayoutItemMapTriggerCustomerId: 'Filter on current customer',
	LayoutItemMapColorfulLogos: 'Always use colorful logos',
	LayoutItemMapLabelSelectedCustomers: '{0} selected users',
	LayoutItemMapDistanceTraveled: 'Distance traveled (in km)',
	LayoutItemCustomerMap: 'Area map',
	LayoutItemCategoriesLogos: 'Categories logos',
	LayoutItemCategoriesLogosList: 'List to display',
	LayoutItemCategoriesLogosCustomersGroups: 'Customer groups',
	LayoutItemCategoriesLogosCustomersTradenames: 'Tradenames',
	LayoutItemCategoriesLogosCustomersPurchaseGroups: 'Purchase groups',
	LayoutItemCategoriesLogosProductsGroups: 'Product groups',
	LayoutItemCategoriesLogosProductsTrademarks: 'Trademarks',
	LayoutItemCategoriesLogosProductsSegmentations: 'Segmentation',
	LayoutItemAttachment: 'Attachment',
	LayoutItemAnalysisReportGrid: 'OLAP report grid',
	LayoutItemAnalysisReportGridAdd: 'Create new report',
	LayoutItemAnalysisReportGridOpen: 'Open report',
	LayoutItemAnalysisReportGridCopy: 'Copy report',
	LayoutItemAnalysisReportGridDelete: 'Delete selected report',
	LayoutItemAnalysisReportGridDeleteConfirmation: 'Do you really want to delete the selected report?',
	LayoutItemAnalysisReportGridFilters: 'OLAP report filters',
	LayoutItemAnalysisReportGridMassDelete: 'Delete all selected reports',
	LayoutItemAnalysisReportGridMassDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>ALL</u></b> displayed reports tagged "to remove".<br>Do you want to continue deleting?',
	LayoutItemAnalysisReportGridMassUpdate: 'Mass update report data',
	LayoutItemAnalysisReportGridMaximize: 'Maximize OLAP grid',
	LayoutItemAnalysisReportGridFailedToLoad: 'Failed to load report list',
	LayoutItemMailGrid: 'Mail grid',
	LayoutItemMailGridMaximize: 'Maximize mail grid',
	LayoutItemMailGridExport: 'Show mail logs',
	LayoutItemMailGridMassUpdate: 'Mass update mails data',
	LayoutItemMailGridMassDelete: 'Delete all selected emails',
	LayoutItemMailGridMassDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>ALL</u></b> displayed mails tagged "to remove".<br>Do you want to continue deleting?',
	LayoutItemMailGridOpen: 'Open mail',
	LayoutItemCustomerTypologies: 'Customer typologies',
	LayoutItemCustomerMemo: 'Customer memo',
	LayoutItemCustomerMemoCards: 'Customer memo as cards',
	LayoutItemCatchmentAreaGrid: 'Catchment area',
	LayoutItemVisitHistoryGrid: 'Visit history grid of a customer',
	LayoutItemVisitHistoryGridConfiguration: 'The configuration of this grid is done in the configuration settings',
	LayoutItemProductGrid: 'Product grid',
	LayoutItemProductForm: 'Product form',
	LayoutItemProductImage: 'Product image',
	LayoutItemProductGridMassDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>ALL</u></b> displayed products tagged "to remove".<br>Do you want to continue deleting?',
	LayoutItemPackagingGrid: 'Packaging',
	LayoutItemPlanningOffer: 'Planning offer',
	LayoutItemVisitForm: 'Visit form',
	LayoutItemLinearForm: 'Shelf form',
	LayoutItemLinearProductForm: 'Shelf product form',
	LayoutItemLinearProductsGrid: 'Shelf products',
	LayoutItemLinearDetailsGrid: 'Shelf products (hybrid support)',
	LayoutItemPageLink:'Page link',
	LayoutItemContextAttachmentGrid: 'Context attachments grid',
	LayoutItemCommonAttachmentBook: 'Context attachments book',
	LayoutItemCommonAttachmentFavorites: 'Context attachments favorites',
	LayoutItemVisitStatements:'Visit statements',
	LayoutItemOrderHeaderForm: 'Order form',
	LayoutItemOrderProductsGrid: 'Order products',
	LayoutItemOrderProductForm: 'Order product form',
	LayoutItemValidOrderGrid: 'Validation orders',
	LayoutItemCustomerHeader: 'Customer header',
	LayoutItemCustomerLastReportGrid: 'Customer last visit report',
	LayoutItemDatasharingGrid: 'External files grid',
	LayoutItemCustomerLastLinearGrid: 'Customer last shelf',
	LayoutItemCustomerTypologyExportTemplate: 'Customer typology export',
	LayoutItemActiveOfferGrid: 'Active offers grid',
	LayoutItemVisitReportForm: 'Visit report',
	LayoutItemCustomerLastLinearExportTemplate: 'Export customer last shelf',
	LayoutItemTypologyGrid: 'Typologies grid',
	LayoutItemTypologyForm: 'Typology form',
	LayoutItemTypologyDetailGrid: 'Typology detail grid',
	LayoutItemOfferDetailGrid: 'Offer products',
	LayoutItemOfferDetailGridMassDelete: 'Delete all offers',
	LayoutItemOfferDetailGridMassDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>ALL</u></b> displayed offer\'s products.<br>Do you want to continue deleting?',
	LayoutItemOfferHeaderGrid: 'Offers grid',
	LayoutItemOfferHeaderGridMassDelete: 'Delete all selected offers',
	LayoutItemOfferHeaderGridMassDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>ALL</u></b> displayed offers tagged "to remove".<br>Do you want to continue deleting?',
	LayoutItemOfferHeaderGridMassUpdate : 'Mass update offers data',
	LayoutItemOfferForm: 'Offer form',
	LayoutItemCustomerValue:'Customer value',
	LayoutItemLinearValue: 'Shelf value',
	LayoutItemOrderValue:'Order value',
	LayoutItemOfferValue:'Offer value',
	LayoutItemProductValue:'Product value',
	LayoutItemVisitValue: 'Visit value',
	LayoutItemImportFileGrid: 'Import file grid',
	LayoutItemExportFileGrid: 'Export file grid',
	LayoutItemDatasharingValue: 'External file value',
	LayoutItemTemplatesFoldersManagement: 'Templates folders management',
	LayoutItemVisitReportHeaderForm: 'Visit report header',
	LayoutItemGanttChartPlanningOffer: 'Planning offer (GanttChart)',
	LayoutItemCustomersMemosGrid: 'Customers memos grid',
	LayoutItemCustomersContactsGrid: 'Customers contacts grid',
	LayoutItemCustomersVisitsGrid: 'Customers visits grid',
	LayoutItemCustomersVisitsGridMassDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>ALL</u></b> displayed visits tagged "to remove".<br>Do you want to continue deleting?',
	LayoutItemFeedbacksGrid: 'Feedbacks grid',
	LayoutItemFeedbackForm: 'Feedback form',
	LayoutItemFeedbackPostCards: 'Discussion thread',
	LayoutItemGanttChartActiveOffer: 'Gantt active offers',
	LayoutItemCustomerGroupImage: 'Customer group image',
	LayoutItemTradenameImage: 'Tradename image',
	LayoutItemPurchaseGroupImage: 'Purchase group image',
	LayoutItemProductGroupImage: 'Product group image',
	LayoutItemTrademarkImage: 'Trademark image',
	LayoutItemSegmentationImage: 'Segmentation image',
	LayoutItemIcon: 'Icon',
	LayoutItemMapOL: 'OpenLayers Map',
	LayoutItemMapHERE: 'Nomadia Map',
	LayoutItemContextAttachment: 'Context attachment',
	LayoutItemCubeGrid: 'Cubes grid',
	LayoutItemCubePatternGrid: 'Sources grid',
	LayoutItemCubeContent: 'Cube content',
	LayoutItemTasksGrid: 'Tasks grid',
	LayoutItemEventForm: 'Event form',
	LayoutParamIconName: 'Icon name',
	LayoutParamIconFontSize: 'Icon size',
	LayoutParamIconFontSizePlaceholder: '(size in pixels)',
	LayoutParamIconColor: 'Icon color',
	LayoutParamIconColorPlaceholder: '(for instance, #000000 is black and #FFFFFF is white)',
	LayoutParamIconBackgroundRadius: 'Background shape',
	LayoutParamIconBackgroundRadiusSquare: 'Square',
	LayoutParamIconBackgroundRadiusRound: 'Round',
	LayoutParamIconPadding: 'Margin',
	LayoutParamIconBackgroundSizePlaceholder: '(size in pixels)',
	LayoutParamIconBackgroundColor: 'Background color',
	LayoutParamIconBackgroundColorPlaceholder: '(for instance, #000000 is black and #FFFFFF is white)',
	LayoutControlMaximize: 'Maximize',
	LayoutControlReduce: 'Reduce',
	LayoutControlConfigurationSelect: 'Configuration selection',
	LayoutParamText: 'Text to show',
	LayoutParamTextDefaultValue: 'New text',
	LayoutParamTextColor: 'Text color',
	LayoutParamBackColor: 'Background color',
	LayoutParamTextColorPlaceholder: '(for instance, #000000 is black and #FFFFFF is white)',
	LayoutParamBackColorPlaceholder: '(for instance, #000000 is black and #FFFFFF is white)',
	LayoutParamFontSize: 'Font size',
	LayoutParamFontSizePlaceholder: '(for instance 12, 15, ..)',
	LayoutParamZoom: 'Zoom',
	LayoutParamZoomPlaceholder: '(for instance 110, 115, ..)',
	LayoutParamHAlign: 'Horizontal alignment',
	LayoutParamHAlignLeft: 'Left',
	LayoutParamHAlignRight: 'Right',
	LayoutParamHAlignCenter: 'Center',
	LayoutParamHShape: 'Background Shape',
	LayoutParamHShapeSquare: 'Square',
	LayoutParamHShapeCircle: 'Circle',
	LayoutParamHShapeRoundedSquare: 'Rounded square',
	LayoutParamHShapeEmpty: 'Empty',
	LayoutParamTestDuration: 'Duration',
	LayoutParamTestDurationPlaceholder: '(N in seconds, 0 for error, empty to randomize)',
	LayoutParamImageAttachment: 'Image to show',
	LayoutParamImageAttachmentPlaceholder: '(must exist in "attachments" folder)',
	LayoutParamImageType: 'Image type',
	LayoutParamImageWidth: 'Image width',
	LayoutParamImageWidthPlaceholder: '(width in pixels or leave it empty for auto-sizing)',
	LayoutParamImageHeight: 'Image height',
	LayoutParamImageHeightPlaceholder: '(height in pixels or leave it empty for auto-sizing)',
	LayoutParamURL: 'URL',
	LayoutParamURLPlaceholder: '(an URL to open when user will click on the link)',
	LayoutParamShowIcon: 'Show icon',
	LayoutParamShowIconPlaceholder: 'If true, the icon will appear on the left',
	LayoutParamOrderBy: 'Order by',
	LayoutParamOrderByDefaultEntry: 'Default order by',
	LayoutParamExecutable: 'Command to run',
	LayoutParamExecutablePlaceholder: '(executable to run, for instance "C:\\Windows\\System32\\notepad.exe")',
	LayoutParamExecutableParameters: 'Command parameters',
	LayoutParamExecutableParametersPlaceholder: '(list of command parameters, for instance the file to open)',
	LayoutParamReportGaugeReport: 'Report to load',
	LayoutParamReportGaugeMeasure: 'Measure',
	LayoutParamReportGaugeLevels: 'Levels (to filter)',
	LayoutParamReportGaugeLayout: 'Layout',
	LayoutParamReportGaugeLayoutSimple: 'Value',
	LayoutParamReportGaugeLayoutCircle: 'Circle',
	LayoutParamReportGaugeLayoutCircular: 'Circular',
	LayoutParamReportGaugeLayoutRectangular: 'Rectangular',
	LayoutParamReportGaugeLayoutNumericOnlyError: 'Circular and rectangular gauge supports numeric value only',
	LayoutParamReportGaugeColors: 'Colors',
	LayoutParamReportGaugeMinValue: 'Scale min value',
	LayoutParamReportGaugeMinMeasure: 'Scale min measure',
	LayoutParamReportGaugeMaxValue: 'Scale max value',
	LayoutParamReportGaugeMaxMeasure: 'Scale max measure',
	LayoutParamReportGaugeSeuilMinValue: 'Target min value',
	LayoutParamReportGaugeSeuilMinMeasure: 'Target min measure',
	LayoutParamReportGaugeSeuilMaxValue: 'Target max value',
	LayoutParamReportGaugeSeuilMaxMeasure: 'Target max measure',
	LayoutParamReportGaugeDecimals: 'Decimal(s)',
	LayoutParamReportGaugeFormat: 'Number format',
	LayoutParamReportGaugeFormatNumber: 'number',
	LayoutParamReportGaugeFormatCurrency: 'currency',
	LayoutParamReportGaugeFormatPercent: 'percent',
	LayoutParamReportGaugeCircleWidth: 'Circle width (%)',
	LayoutParamReportOLAPSelectReport: 'Report to load',
	LayoutParamReportOLAPSelectLevel: 'Level to display',
	LayoutParamReportOLAPSelectAutoSelect: 'Auto-select single value',
	LayoutParamReportOLAPSelectFiltering: 'Enable search',
	LayoutParamReportChartReport: 'Report to load',
	LayoutParamReportChartType: 'Chart Type',
	LayoutParamReportChartLevel: 'Group level',
	LayoutParamReportChartLevel2: 'Second level (if only one measure)',
	LayoutParamReportChartMeasures: 'Measures',
	LayoutParamReportChartMeasuresHelp: 'Comma-separated list. Start typing or use "*" to list all measures',
	LayoutParamReportChartLineMeasure: 'Extra "line" series',
	LayoutParamReportChartLineMeasureHelp: 'Optional measure name to draw a line in front of chart',
	LayoutParamReportChartMaxCategories: 'Max number of groups',
	LayoutParamReportChartMaxCategoriesCaption: 'Others (%COUNT%)',
	LayoutParamReportChartColors: 'Colors',
	LayoutParamReportChartTotalsVisible: 'With totals',
	LayoutParamReportChartLabelsVisible: 'With labels',
	LayoutParamReportChartLabelsAsPercentage: 'With labels as percent',
	LayoutParamReportChartLegendVisible: 'With legend',
	LayoutParamReportChartHideLevelsLabel: 'Hide levels name',
	LayoutParamReportChartExportVisible: 'With export menu',
	LayoutParamReportChartContextFilter: 'Filter page on click',
	LayoutParamReportChartContextFilterHelp: 'If checked, user can click this chart to filter other page elements',
	LayoutParamOnlyValidatedProducts: 'Only validated products',
	LayoutParamTakeQuickInsertFocus: 'Take focus on quick insert',
	LayoutParamOLAPReport: 'Report to load',
	LayoutParamOLAPContextLevels: 'Auto-filter on context',
	LayoutParamOLAPContextLevelsHelp: 'Indicates which page context should filter this item',
	LayoutParamOLAPCustomerPage: 'Detail page for customers',
	LayoutParamOLAPProductPage: 'Detail page for products',
	LayoutParamOLAPOfferPage: 'Detail page for offers',
	LayoutParamOLAPReportFilterType: 'Page filter',
	LayoutParamOLAPReportFilterTypeNo: 'Disabled',
	LayoutParamOLAPReportFilterTypeAuto: 'Auto',
	LayoutParamOLAPReportFilterTypeYes: 'Activated',
	LayoutParamOLAPReportFilterTypeHelp: 'Using "Auto" mode, the element analyses other elements to determine if it should display the option to filter the page on a level. However this mode does not detect the need everytime. That is why the "activated" mode exists.',
	LayoutParamOLAPReportFilterLevels: 'Page filter levels',
	LayoutParamOLAPReportFilterLevelsCustomers: 'Customers',
	LayoutParamOLAPReportFilterLevelsProducts: 'Products',
	LayoutParamOLAPReportFilterLevelsOffers: 'Offers',
	LayoutParamOLAPReportFilterLevelsError: 'Levels to filter the page should be selected only if "Page filter" is in mode "Activated"',
	LayoutParamTemplatesFolders: 'Folders',
	LayoutParamCSS: 'CSS',
	LayoutParamImageCSS: 'Image CSS',
	LayoutParamCSSPlaceholder: '(optional CSS style)',
	LayoutParamOnBuild: 'Action to execute on load',
	LayoutParamOnBuildPlaceholder: '(see documentation for available options)',
	LayoutParamOnClick: 'Action to execute on click',
	LayoutParamOnClickPlaceholder: '(see documentation for available options)',
	LayoutParamFiles: 'Files',
	LayoutParamFields: 'Fields',
	LayoutParamField: 'Field',
	LayoutParamProductFields: 'Product addition fields',
	LayoutParamGridReadonly: 'Readonly',
	LayoutParamGridShowEmpty: 'Show empty lines',
	LayoutParamGridEditPage: 'Edition page',
	LayoutParamGridVisitEditPage: 'Visit edition page',
	LayoutParamShowHeaders: 'Show columns headers',
	LayoutParamAttachmentFile: 'File to show',
	LayoutParamAttachmentFilePlaceholder: '(must exist in "attachments" folder)',
	LayoutParamAttachmentFileAddSelected: 'Add selected file',
	LayoutParamAttachmentFiles: 'Files to show',
	LayoutParamAttachmentFilesPlaceholder: '(comma-separated list of files in "attachments" folder)',
	LayoutParamAttachmentPreview: 'Preview',
	LayoutParamAttachmentPreviewSize: 'Preview size',
	LayoutParamAttachmentLabelPosition: 'Label position',
	LayoutParamAttachmentLabelPositionRight: 'Right',
	LayoutParamAttachmentLabelPositionLeft: 'Left',
	LayoutParamAttachmentLabelPositionBottom: 'Bottom',
	LayoutParamAttachmentLabelPositionTop: 'Top',
	LayoutParamAttachmentLabelFont: 'Label font',
	LayoutParamAttachmentLabelFontPlaceholder: '(for instance Arial, Times New Roman)',
	LayoutParamAttachmentLabelColor: 'Label color',
	LayoutParamAttachmentLabelColorPlaceholder: '(for instance, #000000 is black and #FFFFFF is white)',
	LayoutParamAttachmentLabelFontSize: 'Label size',
	LayoutParamAttachmentLabelFontSizePlaceholder: '(for instance 12, 15, ..)',
	LayoutParamAttachmentLabelCSS: 'Label CSS',
	LayoutParamAttachmentLabelHeight: 'Label height',
	LayoutParamAttachmentLabelHeightPlaceholder: '(height in pixels or leave it empty for height to 20)',
	LayoutParamAttachmentModel: 'Model',
	LayoutParamAttachmentModelOptions: 'Options',
	LayoutParamPageLinkCaption: 'Caption of link',
	LayoutParamPageLinkCaptionHolder: 'Required for tooltip',
	LayoutParamPageLinkImage: 'Image',
	LayoutParamPageLinkImagePlaceholder: '(must exist in "attachments" folder)',
	LayoutParamPageLinkWidth: 'Image width',
	LayoutParamPageLinkWidthPlaceholder: '(width in pixels or leave it empty for auto-sizing)',
	LayoutParamPageLinkHeight: 'Height width',
	LayoutParamPageLinkHeightPlaceholder: '(height in pixels or leave it empty for auto-sizing)',
	LayoutParamPageLink: 'Page',
	LayoutParamConfiguration: 'Configuration',
	LayoutParamFormLabelPosition: 'Label position',
	LayoutParamFormLabelTop: 'Top',
	LayoutParamFormLabelLeft: 'Left',
	LayoutParamFormLabelWithout: 'Hide',
	LayoutParamFormHorizontalAlign: 'Label alignment',
	LayoutParamFormAlignLeft: 'Left',
	LayoutParamFormAlignRight: 'Right',
	LayoutParamFormLayout: 'Form layout',
	LayoutParamFormVertical: 'Vertical',
	LayoutParamFormHorizontal: 'Horizontal',
	LayoutParamFormCardWidth: 'Columns width(px)',
	LayoutParamContactFormByRow: 'Number of form by row',
	LayoutParamPlanningOfferConfiguration: 'Configuration',
	LayoutParamPlanningOfferConfigurationPlaceholder: '(Planning offer configuration id)',
	LayoutParamPlanningOfferType: 'Type',
	LayoutParamPlanningOfferTypePlaceholder: '(List of offer type id to display, separated by commas)',
	LayoutParamPlanningOfferCustomerContextFilter: 'Filter on customer',
	LayoutParamPlanningOfferCustomerContextFilterHelp: 'Show only customer\'s mails',
	LayoutParamPlanningOfferFilter: 'Filter',
	LayoutParamPlanningOfferFilterPlaceholder: '(Condition to be considered)',
	LayoutParamPlanningOfferValidatedProduct: 'Validated products?',
	LayoutParamPlanningOfferValidatedProductAll: 'All',
	LayoutParamPlanningOfferValidatedProductYes: 'Yes',
	LayoutParamPlanningOfferValidatedProductNo: 'No',
	LayoutParamPlanningOfferImage: 'Image to show',
	LayoutParamPlanningOfferImagePlaceholder: '(must exist in "attachments" folder)',
	LayoutParamPlanningOfferImageSize: 'Attachment size',
	LayoutParamPlanningOfferImageSizePlaceholder: '(size in pixels or leave it empty for auto-sizing)',
	LayoutParamPlanningOfferLabelPosition: 'Label position',
	LayoutParamPlanningOfferLabelPositionRight: 'Right',
	LayoutParamPlanningOfferLabelPositionLeft: 'Left',
	LayoutParamPlanningOfferLabelPositionBottom: 'Bottom',
	LayoutParamPlanningOfferLabelPositionTop: 'Top',
	LayoutParamPlanningOfferLabelAlignX: 'Label horizontal alignement',
	LayoutParamPlanningOfferLabelAlignLeft: 'Left',
	LayoutParamPlanningOfferLabelAlignCenter: 'Middle',
	LayoutParamPlanningOfferLabelAlignRight: 'Right',
	LayoutParamPlanningOfferLabelAlignY: 'Label vertical alignement',
	LayoutParamPlanningOfferLabelAlignTop: 'Top',
	LayoutParamPlanningOfferLabelAlignBottom: 'Bottom',
	LayoutParamPlanningOfferLabelFont: 'Label font',
	LayoutParamPlanningOfferLabelFontPlaceholder: '(for instance Arial, Times New Roman)',
	LayoutParamPlanningOfferLabelColor: 'Label color',
	LayoutParamPlanningOfferLabelColorPlaceholder: '(for instance, #000000 is black and #FFFFFF is white)',
	LayoutParamPlanningOfferLabelFontSize: 'Label size',
	LayoutParamPlanningOfferLabelFontSizePlaceholder: '(for instance 12, 15, ..)',
	LayoutParamPlanningOfferLabelCSS: 'Label CSS',
	LayoutParamPlanningOfferLabelHeight: 'Label height',
	LayoutParamPlanningOfferLabelHeightPlaceholder: '(height in pixels or leave it empty for height to 20)',
	LayoutParamVisitStatementsNbColumns: 'Number of columns',
	LayoutParamVisitStatementsNbColumnsPlaceholder:'(Default 1, eg: 1, 2 ,3...)',
	LayoutParamLastLinearGridDateReferenced: 'Shelf date referenced',
	LayoutParamLastLinearExportTemplateDateReferenced: 'Shelf date referenced',
	LayoutParamLastLinearGridFilter: 'Filter',
	LayoutParamTemplateFile: 'Template file',
	LayoutParamShowPrevious: 'Show previous visit report',
	LayoutParamStatus: 'Status',
	LayoutParamMailGridCustomerContextFilter: 'Filter on customer',
	LayoutParamMailGridCustomerContextFilterHelp: 'Show only customer\'s mails',
	LayoutParamVisitStatements: 'Available statements',
	LayoutParamStatementPage: 'Page',
	LayoutParamStatementConfiguration: 'Configuration',
	LayoutParamStatementCaption: 'Caption',
	LayoutParamStatementPageDefault: 'Default',
	LayoutParamVisitStatementsDisplay: 'Display',
	LayoutParamVisitStatementsHorizontal: 'Horizontal',
	LayoutParamVisitStatementsVertical: 'Vertical',
	LayoutParamVisitStatementsOrderAdd: 'Order add',
	LayoutParamVisitStatementsOrderAddVisible: 'Visible',
	LayoutParamVisitStatementsOrderAddVisibleInFirstPosition: 'Visible in first position',
	LayoutParamVisitStatementsOrderAddHide: 'Hide',
	LayoutParamVisitStatementsOrderAddOnly: 'Only order addition',
	LayoutParamImportFile: 'External file',
	LayoutParamImportField: 'Field',
	LayoutParamDatasharingValueTypeAggregate: 'Aggregator',
	LayoutParamDatasharingValueTypeAggregateInvalid: 'Invalid aggregator for this kind of value.',
	LayoutParamDatasharingValueListenContext: 'Context',
	LayoutParamDatasharingValueFilterAggregate: 'Filter',
	LayoutParamDatasharingValueFilterAggregateMissing: 'A filter is required to allow proper update when the context change.',
	LayoutParamAttachmentFilter: 'Filter',
	LayoutParamAttachmentFilterPlaceholder: 'for instance "Attachment type"=1',
	LayoutParamAttachmentEditableBy: 'Editable by',
	LayoutParamAttachmentBookItemCount: 'Thumbnail count',
	LayoutParamAttachmentBookItemCountPlaceholder: '(optional, defaults to 1)',
	LayoutParamAttachmentBookShowDescription: 'Show labels',
	LayoutParamAttachmentBookDirection: 'Layout',
	LayoutParamAttachmentBookDirectionRow: 'horizontal',
	LayoutParamAttachmentBookDirectionColumn: 'vertical',
	LayoutParamAttachmentBookSlideshowInterval: 'Slideshow duration',
	LayoutParamAttachmentBookSlideshowIntervalPlaceholder: '(duration in ms, leave blank to disable slideshow)',
	LayoutParamTemplates: 'Templates',
	LayoutParamTemplateGlobal: 'Global',
	LayoutParamHiddenControls: 'Hidden controls',
	LayoutParamsImportFiles: 'Imports',
	LayoutParamExecuteOnUpload: 'Execute on upload',
	LayoutParamGanttChartStartVisiblePeriod: 'Start visible period',
	LayoutParamGanttChartEndVisiblePeriod: 'End visible period',
	LayoutParamGanttChartRound: 'Round to the area',
	LayoutParamGanttChartSplit: 'Split',
	LayoutParamGanttChartSplitDay: 'Day',
	LayoutParamGanttChartSplitWeek: 'Week',
	LayoutParamGanttChartSplitMonth: 'Month',
	LayoutParamGanttChartSplitWidth: 'Right columns width',
	LayoutParamGanttChartLeftWidth: 'Left width',
	LayoutParamGanttChartTypeBar: 'Bar',
	LayoutParamGanttChartTypeLine: 'Line',
	LayoutParamPlanningOfferGanttChartGroup: 'Group',
	LayoutParamPlanningOfferGanttChartGroupAll: 'Without grouping',
	LayoutParamPlanningOfferGanttChartGroupTradename: 'Tradename',
	LayoutParamPlanningOfferGanttChartGroupCircuit: 'Circuit',
	LayoutParamPlanningOfferGanttChartGroupPurchaseGroup: 'Purchase group',
	LayoutParamPlanningOfferGanttChartGroupTrademark: 'Trademark',
	LayoutParamPlanningOfferGanttChartGroupCustomerGroup: 'Customer group',
	LayoutParamPlanningOfferGanttChartGroupProductGroup: 'Product group',
	LayoutParamPlanningOfferGanttChartVisibleRange: 'Visible range',
	LayoutParamPlanningOfferGanttChartDeliveryShapeCaption: 'Delivery date range shape caption',
	LayoutParamPlanningOfferGanttChartDeliveryShapeColor: 'Delivery date range shape color',
	LayoutParamPlanningOfferGanttChartDeliveryShapeType: 'Delivery date range shape type',
	LayoutParamPlanningOfferGanttChartOperationShapeCaption: 'Operation date range shape caption',
	LayoutParamPlanningOfferGanttChartOperationShapeColor: 'Operation date range shape color',
	LayoutParamPlanningOfferGanttChartOperationShapeType: 'Operation date range shape type',
	LayoutParamPlanningOfferGanttChartVisitShapeCaption: 'Visit date range shape caption',
	LayoutParamPlanningOfferGanttChartVisitShapeColor: 'Visit date range shape color',
	LayoutParamPlanningOfferGanttChartVisitShapeType: 'Visit date range shape type',
	LayoutParamFeedbackGridCustomerContextFilter: 'Filter on customer',
	LayoutParamFeedbackGridCustomerContextFilterHelp: 'Show only customer\'s feedbacks',
	LayoutParamFeedbackGridPublishToAll: 'Publish to all',
	LayoutParamFeedbackGridPublishToAllHelp: 'Automatically publish to all',
	LayoutParamCustomerLimitation: 'Limit to the following customers',
	LayoutParamProductLimitation: 'Limit to the following products',
	LayoutParamOfferLimitation: 'Limit to the following offers',
	LayoutParamBooleanInfoYes: 'Yes',
	LayoutParamBooleanInfoNo: 'No',
	LayoutParamMapBackground: 'Map background',
	LayoutParamMapBackgroundOSM: 'Open Street Map',
	LayoutParamMapBackgroundBingAerial: 'Bing aerial view',
	LayoutParamMapBackgroundBingRoads: 'Bing roads',
	LayoutParamMapBingKey: 'Bing API key',
	LayoutParamMapBingKeyEmptyError: 'The selected background need a key to being used',
	LayoutParamMapMeasuresEmpty: 'Missing measure(s)',
	LayoutParamMapMeasuresWithoutReport: 'A report must be selected',
	LayoutParamCommonAttachmentFile: 'File to show',
	LayoutParamCommonAttachmentFilePlaceholder: '(must exist in "files" folder)',
	LayoutParamValidOrderStartVisitDateFilter: 'Start date',
	LayoutParamCustomerLastReportDisplayMode: 'Display mode',
	LayoutParamCustomerLastReportAllLines: 'All lines',
	LayoutParamCustomerLastReportLinesWithResponseOrPlanned: 'Lines with response or planned',
	LayoutParamCustomerLastReportLinesWithResponse: 'Only lines with response',

	/** --------- Customers -------------- */
	CustomerId: 'Customer ID',
	CustomerUserId: 'Customer manager',
	CustomerTypeId: 'Type',
	CustomerInvoiceId: 'Invoicing Mode',
	CustomerPaymentId: 'Payment Mode',
	CustomerTradenameId: 'Tradename',
	CustomerWarehouseId: 'Warehouse',
	CustomerPurchaseGroupId: 'Purchasing Group',
	CustomerPurchaseGroupXId: 'Purchasing Group {0}',
	CustomerCircuitId: 'Circuit',
	CustomerCircuitXId: 'Circuit {0}',
	CustomerEan: 'Customer EAN',
	CustomerCode: 'Customer code',
	CustomerName: 'Customer name',
	CustomerImage: 'Customer image',
	CustomerSmallImage: 'Small customer image',
	CustomerInactive: 'Inactive',
	CustomerProspect: 'Prospect',
	CustomerDirect: 'Direct',
	CustomerDistributor: 'Distributor (Y/N)',
	CustomerDistributorId: 'Distributor',
	CustomerSurface: 'Surface',
	CustomerCatp: 'CATP',
	CustomerFranco: 'Franco',
	CustomerDiscount: 'Discount',
	CustomerExpiry: 'Expiry',
	CustomerPhone: 'Phone',
	CustomerFax: 'Fax',
	CustomerEmail: 'Email',
	CustomerAdress1: 'Address',
	CustomerAdress2: 'Address 2',
	CustomerZipCode: 'Zip code',
	CustomerCity: 'City',
	CustomerState: 'State',
	CustomerCounty: 'County',
	CustomerCountry: 'Country',
	CustomerComments: 'Comments',
	CustomerDeliveryAdress1: 'Delivery - Address',
	CustomerDeliveryAdress2: 'Delivery - Address 2',
	CustomerDeliveryZipCode: 'Delivery - Zip Code',
	CustomerDeliveryCity: 'Delivery - City',
	CustomerDeliveryState: 'Delivery - State',
	CustomerDeliveryCounty: 'Delivery - County',
	CustomerDeliveryCountry: 'Delivery - Country',
	CustomerDeliveryComments: 'Delivery - Comments',
	CustomerInvoiceAdress1: 'Invoicing - Address',
	CustomerInvoiceAdress2: 'Invoicing - Address 2',
	CustomerInvoiceZipCode: 'Invoicing - Zip Code',
	CustomerInvoiceCity: 'Invoicing - City',
	CustomerInvoiceState: 'Invoicing - State',
	CustomerInvoiceCounty: 'Invoicing - County',
	CustomerInvoiceCountry: 'Invoicing - Country',
	CustomerInvoiceComments: 'Invoicing - Comments',
	CustomerValidated: 'Validated',
	CustomerCreateDate: 'Create Date',
	CustomerUpdateDate: 'Update Date',
	CustomerSectorId: 'Sector',
	CustomerSectorDepthId: 'Sector {0}',
	CustomerSectorCode: 'Sector Code',
	CustomerSectorVisitTarget: 'Sector Visit Target',
	CustomerOverVisitedPercent: 'Over-visited percent',
	CustomerUnderVisitedPercent: 'Under-visited percent',
	CustomerMemo: 'Memo',
	CustomerAttachment: 'Customer attachment',
	CustomerTypology: 'Associate typologies',
	CustomerReferenceTypologies: 'Reference typologies',
	CustomerContact: 'Contact',
	CustomerOrderWaiting: 'Waiting order count',
	CustomerOrderRejected: 'Rejected order count',
	CustomerOrderValidated: 'Validated order count',
	CustomerDoneVisitCount: 'Done visit count',
	CustomerLastVisitDate: 'Last visit date',
	CustomerPreviousEventDate: 'Previous event date (Planner)',
	CustomerNextEventDate: 'Next planned event',
	CustomerNextVisitDate: 'Next visit date',
	CustomerTypologyUpdateDate: 'Typology update date',
	CustomerTypologyWaitingValidation: 'Typology waiting validation',
	CustomerReinitialisationLinearDate: 'Reset shelf date',
	CustomerReinitialisationOrderDate: 'Order dates reset',
	CustomerNewName: 'New customer',
	CustomerDeletePending: 'To delete',
	CustomerAvailabilities: 'Availabilities',

	CustomersFailedToLoad: 'Failed to load customers',

	CustomerGridFailedToLoad: 'Failed to load customer data',
	CustomerGridDeleteConfirmation: 'Do you really want to delete the selected customer?',
	CustomerGridDeleteFailed: 'Failed to delete customer',
	CustomerGridSaveSuccess: 'Customer saved',
	CustomerGridSaveFailed: 'Failed to save customer',
	CustomerGridOpen: 'Open',
	CustomerGridCreate: 'Create customer',
	CustomerGridMail: 'Send a mail',
	CustomerGridDelete: 'Delete the selected customer',
	CustomerGridExports: 'Customers exports',
	CustomerGridOpenDayVisit: 'Open day visit',
	CustomerGridCreateVisit: 'Create visit',
	CustomerGridCreateOrder: 'Create order {0}',
	CustomerGridAddMenuToolTip: 'Customer grid create menu',

	CustomerFormFailedToLoad: 'Failed to load customer data',
	CustomerFormSaveSuccess: 'Customer was saved',
	CustomerFormSaveFailed: 'Failed to save customer',

	CustomerSelectPopinTitle: 'Select customer',
	CustomerGridFilters: 'Customers filters',
	CustomerGridMassupdate: 'Mass update customers data',
	CustomerGridMassupdatePopin: 'Mass update',
	CustomerGridMaximize: 'Maximize customer grid',
	CustomerGridMassdelete: 'Remove selected items',
	CustomerGridCustomerFilter: 'Filter on current item',
	CustomerGridCustomerFilterOnCustomerGroup: 'Customer group',
	CustomerGridCustomerFilterOnPurchaseGroup: 'Purchase group',
	CustomerGridCustomerFilterOnTradename: 'Tradename',
	CustomerGridCreateEvents: 'Add to planner',

	CustomerRestoreConfirmMessage: 'A deleted customer ({0}) used the code {1}, do you wish to reactivate it?',
	CustomerMessageErrorCodeAlreadyUsed: 'Code already used, delete it to reuse it',
	CustomerMessageErrorCodeAlreadyUsedDeleted: 'Code already used but deleted, create it to reuse it',
	/**---------- Contacts magasins ---------- */
	ContactCaption: 'Contact',
	ContactLastName: 'Last Name',
	ContactFirstName: 'First Name',
	ContactCode: 'Contact Code',
	ContactFunctionId: 'Function',
	ContactDepartmentIds: 'Departments',
	ContactPhone: 'Phone',
	ContactCellPhone: 'Cell Phone',
	ContactFax: 'Fax',
	ContactEmail: 'Email',
	ContactCivility: 'Civility',
	ContactComments: 'Comment',
	ContactAvailableAM: '{0} AM',
	ContactAvailablePM: '{0} PM',
	ContactDayAvailability: 'Available',
	ContactHalfDayAvailability: 'Available (½)',
	ContactAM: 'AM',
	ContactPM: 'PM',
	ContactEditPopinTitle: 'Contact',
	ContactMarket: 'Market restricted',
	ContactDeletePending: 'To delete',
	ContactCreateUserId: 'Created by',
	ContactCreateDate: 'Creation date',
	ContactUpdateUserId: 'Update by',
	ContactUpdateDate: 'Update date',

	ContactSelectPopinTitle: 'Select contacts',
	ContactGridDeleteConfirmation: 'Do you really want to delete the selected contact?',
	ContactGridDeleteFailed: 'Failed to delete contact',
	ContactGridFailedToLoad: 'Failed to load contacts data',
	ContactGridSaveSuccess: 'Contact saved',
	ContactGridSaveFailed: 'Failed to save contacts',
	ContactGridAdd: 'Add a contact',
	ContactGridDelete: 'Delete the selected contact',
	ContactGridFilters: 'Contacts filters',
	ContactGridMaximize: 'Maximize contact grid',

	ContactFormDeleteConfirmation: 'Do you really want to delete the selected contact data?',
	ContactFormDeleteFailed: 'Failed to delete contact data',
	ContactFormFailedToLoad: 'Failed to load contact data',
	ContactFormSaveSuccess: 'Contact saved',
	ContactFormSaveFailed: 'Failed to save contact data',
	ContactFormAdd: 'Add a contact',
	ContactFormEdit: 'Edit the contact',
	ContactFormDelete: 'Delete the selected contact',
	ContactFormMaximize: 'Maximize contact cards',

	/**---------- Typologies magasins ---------- */
	CustomerTypologyLevelActive: 'Level {0}',
	CustomerTypologyViewAll: 'Display all items',
	CustomerTypologyViewCompact: 'Hide empty items',
	CustomerTypologyClearLabel: 'Clear',
	CustomerTypologyClearConfirmation: 'Do you really want to delete all items?',
	CustomerTypologyParamLevelWidth: 'Size of column typology levels (px)',
	CustomerTypologyParamOnlyCompletedItems: 'Only completed items',
	CustomerTypologyParamValidationOfChanges: 'Validation of changes',
	CustomerTypologyParamValidationBy: 'Validation by',
	CustomerTypologySaveSuccessMessage: 'Customer typology saved',
	CustomerTypologySaveFailedMessage: 'Failed to save customer typology',
	CustomerTypologyReferenceTypologyLabel: 'Reference typology: ',
	CustomerTypologyReferenceTypologyNone: 'None',

	CustomerTypologyMassUpdate: 'Mass update typologies data',
	CustomerTypologyMassUpdatePopinTitle: 'Typologies update',
	CustomerTypologyMassUpdatePopinCustomerLabel: 'Customer',
	CustomerTypologyMassUpdatePopinEmptyLevel: 'Empty',
	CustomerTypologyMassUpdatePopinLevel: 'Set level {0}',
	CustomerTypologyMassUpdatePopinSaveFailed: 'Failed to save customer typologies',

	/** ---------- Memo magasins ---------- */
	CustomerMemoDate: 'Memo date',
	CustomerMemoUserName: 'User',
	CustomerMemoContent: 'Note',
	CustomerMemoWithMarket: 'Show "Market" column',
	CustomerMemoMarket: 'Market {0}',
	CustomerMemoAddLabel: 'Add memo',
	CustomerMemoDeleteLabel: 'Delete',
	CustomerMemoDeleteConfirmation: 'Do you really want to delete the selected memo?',
	CustomerMemoFilterLabel: 'Filter memos',
	CustomerMemoMaximize: 'Maximize memo table',
	CustomerMemoMaxShow: 'Maximum number of memos to display',
	CustomerMemoShowOwnerOnly: 'Show only my memos',

	/** ------- Zone de chalandise -------- */
	CatchmentAreaAddCustomers: 'Add to catchment area',
	CatchmentAreaDeleteCustomer: 'Delete selected customer of catchment area',
	CatchmentAreaDeleteCustomers: 'Delete selected customers of catchment area',
	CatchmentAreaGridDeleteConfirmation: 'Do you really want to delete the selected area data?',
	CatchmentAreaGridDeleteFailed: 'Failed to delete selected customer in catchment area',
	CatchmentAreaGridFailedToLoad: 'Failed to load catchment area data',
	CatchmentAreaGridSaveSuccess: 'Catchment area saved',
	CatchmentAreaGridSaveFailed: 'Failed to save catchement area',
	CatchmentAreaGridFilters: 'Catchment area filters',
	CatchmentAreaGridMaximize: 'Maximize catchment area grid',
	CatchmentAreaModalSelectCustomerValidate: 'Validate',
	CatchmentAreaModalSelectCustomerCancel: 'Cancel',

	/** ------- Visit -------- */
	VisitId: 'Visit id',
	VisitCode: 'Visit code',
	VisitUserId: 'Visit creator',
	VisitVisitDate: 'Visit date',
	VisitNextVisitDate: 'Next visit',
	VisitStartTime: 'Visit start time',
	VisitEndTime: 'Visit end time',
	VisitDuration: 'Visit duration (min)',
	VisitIsVisit: 'Is Visit',
	VisitIsVisitDiff: 'Is Visit diff',
	VisitValid: 'Valid',
	VisitImportDate: 'Import date',
	VisitComments: 'Visit comment',
	VisitAttachment: 'Visit attachment',
	VisitNextEventDate: 'Next planned event',
	VisitHasLinear: 'Shelf',
	VisitHasValidLinear: 'Valid shelf',
	VisitHasReport: 'Report',
	VisitHasValidReport: 'valid report',
	VisitOrderCount: 'Orders',
	VisitValidOrderCount: 'Valid orders',
	VisitExpiry: 'Expiry',
	VisitEventType: 'Event type',
	VisitGridOpen: 'Open',
	VisitGridMail: 'Send a mail',
	VisitGridCreate: 'Create visit',
	VisitGridDelete: 'Delete selected visit',
	VisitGridFailedToLoad: 'Failed to load visits data',
	VisitGridDeleteConfirmation: 'Do you really want to delete the selected visit data?',
	VisitGridDeleteFailed: 'Failed to delete visit data',
	VisitGridFilters: 'Visit grid filters',
	VisitDeletePending: 'To delete',

	VisitFormFailedToLoad: 'Failed to load visit data',
	VisitFormSaveSuccess: 'Visit was saved',
	VisitFormSaveFailed: 'Failed to save visit',
	
	/* Grille des visites des clients */
	CustomersVisitsGridFilterLabel: 'Filter visits',
	CustomersVisitsGridMassdelete: 'Delete all selected visits',
	CustomersVisitsGridDeleteConfirmation: 'Do you really want to delete the selected visit?',
	CustomersVisitsGridMassUpdate: 'Mass update visits data',
	CustomersVisitsGridMaximize: 'Maximize visits grid',
	CustomersVisitsGridFailedToLoad: 'Failed to load visit list',
	CustomersVisitsGridFailedToSave: 'Failed to delete visits',
	CustomersVisitsGridVisitGroupField: 'Visits',
	CustomersVisitsGridCustomerGroupField: 'Customers',

	/** ------- Linear grid -------- */
	LinearPreviousSuffix: '(N-1)',
	LinearHeaderCode: 'Shelf code',
	LinearHeaderValid: 'Valid',
	LinearHeaderComment: 'Comment',
	LinearHeaderDNProductInno: 'DN product inno',
	LinearHeaderDNTopProduct: 'DN top product',
	LinearGridOpen: 'Open',
	LinearGridMail: 'Send a mail',
	LinearGridFailedToLoad: 'Failed to load visits data',
	LinearGridDelete: 'Delete selected shelf',
	LinearGridDeleteConfirmation: 'Do you really want to delete the selected shelf?',
	LinearGridPleaseSelectConfiguration: 'Please select configuration',
	LinearGridFilters: 'Shelf grid filters',
	LinearFormFailedToLoad: 'Failed to load shelf head',
	LinearFormSaveSuccess: 'Shelf header was saved',
	LinearFormSaveFailed: 'Failed to save shelf head',

	LinearDetailAssociateLevel: 'Associate typology',
	LinearDetailProductCodeTypo: 'Typo ref code',
	LinearDetailProductSegmentationTypo: 'Typo ref segmentation',
	LinearDetailApplicationStartDate: 'Application start date',
	LinearDetailPresence: 'Presence',
	LinearDetailPresenceHR: 'Presence Out',
	LinearDetailDereference: 'Dereferenced',
	LinearDetailRupture: 'Empty',
	LinearDetailFacing: 'Facing',
	LinearDetailPvc: 'PVC',
	LinearDetailPvcSup: 'PVC 2',
	LinearDetailNiveau: 'Level',
	LinearDetailMobilier1: 'Items 1',
	LinearDetailMobilier2: 'Items 2',
	LinearDetailMobilier3: 'Items 3',
	LinearDetailMobilier4: 'Items 4',
	LinearDetailStockRayon: 'Shop stock',
	LinearDetailStockReserve: 'Available stock',
	LinearDetailPromo: 'Promo',
	LinearDetailPosition: 'Position',
	LinearDetailPositionEmptyLabel: 'empty',
	LinearDetailReferenced: 'Referenced',
	LinearDetailLD: 'LD (mm)',
	LinearDetailLDMobilier1: 'Items 1 LD (cm)',
	LinearDetailLDMobilier2: 'Items 2 LD (cm)',
	LinearDetailLDMobilier3: 'Items 3 LD (cm)',
	LinearDetailLDMobilier4: 'Items 4 LD (cm)',
	LinearDetailLDTotal: 'Total LD (cm)',
	LinearDetailStockTotal: 'Total stock',
	LinearProductsGridDeleteConfirmation: 'Do you really want to delete the selected shelf products?',
	LinearProductsGridFailedToLoad: 'Failed to load shelf products',
	LinearDetailProductGroupField: 'Product',
	LinearDetailLinearGroupField: 'Shelf',
	LinearDetailProductsAdd: 'Add products to shelf',
	LinearPreviousLinearGroupField: 'Shelf(N-1)',
	LinearDetailProductsQuickInsertPlaceHolder: 'Add product',
	LinearDetailProductsGridExports: 'Shelf export',
	LinearDetailProductsOpen: 'Open product form',
	LinearDetailProductsDelete: 'Delete product from shelf',
	LinearDetailProductsRecalculateTypology: 'Reload based on customer typology',
	LinearDetailProductsDeleteNoUsedProducts: 'Delete no longer available products',
	LinearDetailProductsGridFilters: 'Shelf products filters',
	LinearDetailProductsGridMaximize: 'Maximize shelf products grid',
	LinearDetailProductsHideEmptyRows: 'Hide empty rows',
	LinearDetailProductsRenumberPositions: 'Renumber positions',
	LinearDetailTypologyMovement: 'Typology info.',
	
	LinearProductFormFailedToLoad: 'Failed to load shelf product',

	/** ------- Report grid -------- */
	VisitReportCode: 'Report code',
	VisitReportValid: 'Valid',
	VisitReportComment: 'Comment',
	VisitReportGridOpen: 'Open',
	VisitReportGridMail: 'Send a mail',
	VisitReportGridFailedToLoad: 'Failed to load visits reports data',
	VisitReportGridDelete: 'Delete the selected visit report',
	VisitReportGridDeleteConfirmation: 'Do you really want to delete the selected report?',
	VisitReportGridPleaseSelectConfiguration: 'Please select configuration',
	VisitReportGridFilters: 'Report grid filters',
	VisitReportGridMaximize: 'Maximize last visit report customer grid',
	VisitReportPrevious: 'Last visit',
	VisitReportCurrent: 'Current visit',
	VisitReportFormFailedToLoad: 'Failed to load visit report',
	VisitReportFormFailedToSave: 'Failed to save visit report',
	VisitReportFormMaximize: 'Maximize  visit report',
	VisitReportFormExports: 'Export visit report',
	VisitReportHeaderFormFailedToLoad: 'Failed to load header visit report',
	VisitReportFilterLabel: 'Filter questions',

	ReportDetailGroupInfo: 'Rubrique',
	ReportDetailInfo: 'Question',
	ReportDetailVal: 'Answer',
	ReportDetailDone: 'Done',
	ReportDetailComments: 'Comments',
	ReportDetailWasPlanned: 'Was Planned',
	ReportDetailWasPlannedComments: 'Was Planned (Comment)',
	ReportDetailIsPlanned: 'Is Planned',
	ReportDetailIsPlannedComments: 'Is Planned (Comment)',

	/** ------- Order grid -------- */
	Order: 'Order',
	OrderHeaderId: 'Order id',
	OrderHeaderType: 'Order type',
	OrderHeaderCode: 'Order code',
	OrderHeaderReference: 'Reference',
	OrderHeaderOrderDate: 'Order date',
	OrderHeaderDeliveryDate: 'Delivery date',
	OrderHeaderMatplv: 'MATPLV',
	OrderHeaderValid: 'Valid',
	OrderHeaderComments: 'Comments',
	OrderHeaderTheme: 'Theme',
	OrderHeaderOffer: 'Offer',
	OrderHeaderAttachment: 'Order attachment',
	OrderHeaderQuestion1: 'Question 1',
	OrderHeaderQuestion2: 'Question 2',
	OrderHeaderQuestion3: 'Question 3',
	OrderHeaderQuestion4: 'Question 4',
	OrderHeaderQuestion5: 'Question 5',
	OrderHeaderQuestion6: 'Question 6',
	OrderHeaderStatusId: 'Status',
	OrderHeaderStatusComments: 'Status comments',
	OrderHeaderStatusDate: 'Status date',
	OrderHeaderStatusUserId: 'Status user',
	OrderHeaderOperationSDate: 'Operation start date',
	OrderHeaderOperationEDate: 'Operation end date',
	OrderHeaderVisitSDate: 'Visit start date',
	OrderHeaderVisitEDate: 'Visit end date',
	OrderHeaderDeliverySDate: 'Delivery start date',
	OrderHeaderDeliveryEDate: 'Delivery end date',
	OrderHeaderExtractDate: 'Extract date',
	OrderHeaderInvoiceAdress1: 'Invoicing - Address',
	OrderHeaderInvoiceAdress2: 'Invoicing - Address 2',
	OrderHeaderInvoiceZipCode: 'Invoicing - Zip Code',
	OrderHeaderInvoiceCity: 'Invoicing - City',
	OrderHeaderInvoiceState: 'Invoicing - State',
	OrderHeaderInvoiceCounty: 'Invoicing - County',
	OrderHeaderInvoiceCountry: 'Invoicing - Country',
	OrderHeaderInvoiceComments: 'Invoicing - Comments',
	OrderHeaderFranco: 'Franco',
	OrderHeaderDiscount: 'Discount',
	OrderHeaderExpiry: 'Expiry',
	OrderHeaderPaymentId: 'Payment Mode',
	OrderHeaderInvoiceId: 'Invoicing Mode',
	OrderHeaderDeliveryAdress1: 'Delivery - Address',
	OrderHeaderDeliveryAdress2: 'Delivery - Address 2',
	OrderHeaderDeliveryZipCode: 'Delivery - Zip Code',
	OrderHeaderDeliveryCity: 'Delivery - City',
	OrderHeaderDeliveryState: 'Delivery - State',
	OrderHeaderDeliveryCounty: 'Delivery - County',
	OrderHeaderDeliveryCountry: 'Delivery - Country',
	OrderHeaderDeliveryComments: 'Delivery - Comments',
	OrderHeaderDistributorId: 'Distributor ref',
	OrderHeaderSignature: 'Signature',

	OrderHeaderSignatureSaveSuccess: 'Signature was saved',
	OrderHeaderSignatureSaveFailed: 'Failed to save signature',
	OrderHeaderSignatureClickToSign: 'Click to sign',
	OrderHeaderSignatureNoSignature: 'No signature',
	OrderHeaderSignatureFailedToLoad: 'Failed to load image',

	OrderNoConfiguration: 'No configuration is available for this order',
	OrderCreatePopinPleaseSelectAType: 'Please select type',
	OrderCreatePopin: 'Order creation',
	OrderCreatePleaseSelectOffer: 'Select offer to copy',
	OrderCreatePleaseSelectPreviousOrder: 'Select a previous order',

	OrderGridOpen: 'Open order',
	OrderGridMail: 'Send a mail',
	OrderGridFailedToLoad: 'Failed to load client order data',
	OrderGridDeleteConfirmation: 'Do you really want to delete the selected order?',
	OrderGridPleaseSelectConfiguration: 'Please select configuration',
	OrderGridDelete: 'Delete selected order',

	VisitOrdersFailedToLoad: 'Failed to load orders data',
	VisitOrdersAdd:'add order',
	VisitOrderGridSaveSuccess: 'Orders modifications was saved',
	VisitOrderGridSaveFailed: 'Failed to save orders modifications',
	VisitOrderGridFilters: 'Order grid filters',

	VisitStatementsAdd: 'Add',
	VisitStatementsLinearDeleteConfirmation: 'Do you really want to delete the selected shelf?',
	VisitStatementsVisitReportDeleteConfirmation: 'Do you really want to delete the selected visit report?',
	VisitStatementsOrderDeleteConfirmation: 'Do you really want to delete the selected order?',
	VisitStatementsOpen: 'Open',

	OrderFormFailedToLoad: 'Failer to load order',
	OrderSelectOfferToCopy: 'Select offer to copy',

	OrderDetailProductsQuickInsertPlaceHolder: 'Add product',
	OrderDetailProductsOpen: 'Open product form',
	OrderDetailProductsAdd: 'Add product',
	OrderDetailProductsDelete: 'Delete product from ordercommande',
	OrderDetailProductsDeleteNoUsedProducts: 'Delete no longer available products',
	OrderDetailProductsGridFilters: 'Products filter',
	OrderDetailProductsGridMaximize: 'Maximize order products grid',
	OrderDetailProductsCopyOffer: 'Copy offer',
	OrderDetailProductGroupField: 'Product',
	OrderDetailLinearGroupField: 'Shelf',
	OrderDetailOrderGroupField: 'Order',
	OrderDetailProductsGridExports: 'Export order',
	OrderProductsGridFailedToLoad: 'Failed to load orders data',
	OrderProductsGridFailedToCopyOffer: 'Failed to load offer to copy',
	OrderProductsGridDeleteConfirmation: 'Do you really want to delete the selected order?',
	OrderDetailProductsHideEmptyRows: 'Hide empty rows',

	OrderDetailOfferId: 'Promotion',
	OrderDetailOrderDateReferenced: 'Date referenced',
	OrderDetailIsFromOffer: 'Is offer',
	OrderDetailNegociatedPrice: 'Negociated price',
	OrderDetailPackagingId: 'Packaging id',
	OrderDetailPackagingCode: 'Packaging code',
	OrderDetailPackagingCaption: 'Packaging',
	OrderDetailOrderUcQuantity: 'UC quantity',
	OrderDetailOrderPcbQuantity: 'PCB quantity',
	OrderDetailOrderQtyDiscount1: 'Order discount 1',
	OrderDetailOrderQtyDiscount2: 'Order discount 2',
	OrderDetailOrderQtyDiscount3: 'Order discount 3',
	OrderDetailOrderQtyDiscount: 'Order discount',
	OrderDetailOrderPctDiscount1: 'Order discount 1 %',
	OrderDetailOrderPctDiscount2: 'Order discount 2 %',
	OrderDetailOrderPctDiscount3: 'Order discount 3 %',
	OrderDetailOrderPctDiscount: 'Order discount %',
	OrderDetailOrderValDiscount1: 'Order discount 1 €',
	OrderDetailOrderValDiscount2: 'Order discount 2 €',
	OrderDetailOrderValDiscount3: 'Order discount 3 €',
	OrderDetailOrderValDiscount: 'Order discount €',
	OrderDetailOrderUcCalcPrice: 'Calc order UC price',
	OrderDetailOrderPcbCalcPrice: 'Calc order PCB price',
	OrderDetailOrderUcPrice: 'User order UC price',
	OrderDetailOrderPcbPrice: 'User order PCB price',
	OrderDetailPromoUcQuantity: 'Promo UC quantity',
	OrderDetailPromoPcbQuantity: 'Promo PCB quantity',
	OrderDetailPromoQtyDiscount1: 'Promo discount 1',
	OrderDetailPromoQtyDiscount2: 'Promo discount 2',
	OrderDetailPromoQtyDiscount3: 'Promo discount 3',
	OrderDetailPromoQtyDiscount: 'Promo discount',
	OrderDetailPromoPctDiscount1: 'Promo discount 1 %',
	OrderDetailPromoPctDiscount2: 'Promo discount 2 %',
	OrderDetailPromoPctDiscount3: 'Promo discount 3 %',
	OrderDetailPromoPctDiscount: 'Promo discount %',
	OrderDetailPromoValDiscount1: 'Promo discount 1 €',
	OrderDetailPromoValDiscount2: 'Promo discount 2 €',
	OrderDetailPromoValDiscount3: 'Promo discount 3 €',
	OrderDetailPromoValDiscount: 'promo discount €',
	OrderDetailPromoUcCalcPrice: 'Calc promo UC price',
	OrderDetailPromoPcbCalcPrice: 'Calc promo PCB price',
	OrderDetailPromoUcPrice: 'User promo UC price',
	OrderDetailPromoPcbPrice: 'User promo PCB price',
	OrderDetailInvoicedUcQuantity: 'Invoiced UC quantity',
	OrderDetailInvoicedPcbQuantity: 'Invoiced PCB quantity',
	OrderDetailFreeUcQuantity: 'Free UC quantity',
	OrderDetailFreePcbQuantity: 'Free PCB quantity',
	OrderDetailTotalUcQuantity: 'Total UC quantity',
	OrderDetailTotalPcbQuantity: 'Total PCB quantity',
	OrderDetailBackUcQuantity: 'Back UC quantity',
	OrderDetailInvoicedUcWeight: 'Invoiced UC weight',
	OrderDetailInvoicedPcbWeight: 'Invoiced PCB weight',
	OrderDetailFreeUcWeight: 'Free UC weight',
	OrderDetailFreePcbWeight: 'Free PCB weight',
	OrderDetailTotalUcWeight: 'Total UC weight',
	OrderDetailTotalPcbWeight: 'Total PCB weight',
	OrderDetailBackUcWeight: 'Back UC weight',
	OrderDetailInvoicedUcPrice: 'Invoiced UC price',
	OrderDetailInvoicedPcbPrice: 'Invoiced PCB price',
	OrderDetailFreeUcPrice: 'Free UC price',
	OrderDetailFreePcbPrice: 'Free PCB price',
	OrderDetailTotalUcPrice: 'Total UC price',
	OrderDetailTotalPcbPrice: 'Total PCB price',
	OrderDetailBackUcPrice: 'Back UC price',
	OrderDetailTotalUcCost: 'Total UC cost',
	OrderDetailTotalPcbCost: 'Total PCB cost',
	OrderDetailTotalCost: 'Total cost',

	ValidOrderGridFilterOnCustomer: 'Filter on current customer',
	ValidOrderGridStatus: 'Change status',
	ValidOrderGridOpen: 'Show order',
	ValidOrderGridMaximize: 'Maximize orders validation',
	ValidOrderGridFailed: 'Failed to load orders validation',
	ValidOrderCustomerGroupField: 'Customer',
	ValidOrderVisitGroupField: 'Visit',
	ValidOrderGroupField: 'Order',
	ValidOrderGridFilter: 'Orders validation filters',
	ValidOrderGridDelete: 'Delete selected order',
	ValidOrderGridMail: 'Send a mail',
	ValidOrderGridExports: 'Export orders',
	ValidOrderGridDeleteConfirmation: 'Do you really want to delete the selected order?',
	
	OrderProductFormFailedToLoad: 'Failed to load order product',

	/** ---------- Status  ---------- */
	StatusState: 'Status',
	StatusUser: 'Status user',
	StatusDate: 'Status date',
	StatusComments: 'Comments',

	PopinSelectStatus: 'Select status',

	/** --------- Report -------------- */
	ReportId: '#',
	ReportCaption: 'Caption',
	ReportCube: 'Cube',
	ReportCubeId: 'Cube #',
	ReportVisible: 'Visible',
	ReportZC: 'ZC',
	ReportFilterScopes: 'Apply user\'s scopes',
	ReportFilterSectors: 'Apply user\'s sectors',
	ReportRestrictOnlineForOffline: 'Restrict online access for offline users',
	ReportCreateUser: 'User',
	ReportUpdateDate: 'Modified on',
	ReportPublication: 'Publication',
	ReportPublicationTo: 'Published to',
	ReportLastDate: 'Last used on',
	ReportDeletePending: 'To delete',

	/** ---------- VisitHistory ---------- */
	VisitHistoryVisits: 'Visits',
	VisitHistoryLinears: 'Shelves',
	VisitHistoryReports: 'Report',
	VisitHistoryGridViews: 'View / configuration selection',
	VisitHistoryGridFilters: 'History grid filters',
	VisitHistoryGridMaximize: 'Maximize visit history grid',

	/** --------- Mail -------------- */
	MailId: '#',
	MailUserId: 'User',
	MailUserEmail: 'Email',
	MailModel: 'Model',
	MailModelDefault: 'None',
	MailModelCustomer: 'Customer',
	MailModelVisit: 'Visit',
	MailModelLinear: 'Shelf',
	MailModelOrder: 'Order',
	MailModelVisitReport: 'Visit report',
	MailModelOffer: 'Offer',
	MailModelFeedback: 'Feedback',
	MailState: 'State',
	MailStateFailed: 'Failed',
	MailStateWaiting: 'Waiting',
	MailStateSent: 'Sent',
	MailStateCancelled: 'Cancelled',
	MailReplyTo: 'Reply to',
	MailSendTo: 'To',
	MailSendCc: 'CC to',
	MailSendBcc: 'BCC to',
	MailSubject: 'Subject',
	MailSendDate: 'Sent on',
	MailCreateDate: 'Creation date',
	MailCustomerId: 'Customer id',
	MailCustomerCode: 'Customer code',
	MailCustomerName: 'Customer name',
	MailPurchaseGroupId: 'Purchase group id',
	MailPurchaseGroupCode: 'Purchase group code',
	MailPurchaseGroupCaption: 'Purchase group caption',
	MailCircuitId: 'Circuit id',
	MailCircuitCode: 'Circuit code',
	MailCircuitCaption: 'Circuit caption',
	MailTradenameId: 'Tradename id',
	MailTradenameCode: 'Tradename code',
	MailTradenameCaption: 'Tradename caption',
	MailWarehouseId: 'Warehouse id',
	MailWarehouseCode: 'Warehouse code',
	MailWarehouseCaption: 'Warehouse caption',
	MailVisitId: 'Visit id',
	MailVisitDate: 'Visit date',
	MailLinearId: 'Shelf id',
	MailOrderId: 'Order id',
	MailReportId: 'Report id',
	MailSendFailed: 'Retransmit',
	MailSendStopped: 'Cancel',
	MailAttachments: 'Attachments',
	MailDeletePending: 'To delete',

	/**----------Attachment-----------*/
	CommonAttachmentId: '#',
	CommonAttachmentObjectId: 'Object',
	CommonAttachmentAvailableStartDate: 'Available start date',
	CommonAttachmentAvailableEndDate: 'Available end date',
	CommonAttachmentExtractDate: 'Attachment extract date',
	CommonAttachmentCode: 'Code',
	CommonAttachmentUserCompleteName: 'User',
	CommonAttachmentCreateDate: 'Attachment create date',
	CommonAttachmentCreateUserId: 'Attachment created by',
	CommonAttachmentUpdateDate: 'Attachment update date',
	CommonAttachmentUpdateUserId: 'Attachment updated by',
	CommonAttachmentDeleteDate: 'Attachment delete date',
	CommonAttachmentDeleteUserId: 'Attachment deleted by',
	CommonAttachmentDescription: 'Attachment description',
	CommonAttachmentFilename: 'Filename',
	CommonAttachmentUniqueName: 'Unique name',
	CommonAttachmentSize: 'Attachment size',
	CommonAttachmentUnitBytes: ' B',
	CommonAttachmentUnitKiloBytes: ' kB',
	CommonAttachmentUnitMegaBytes: ' MB',
	CommonAttachmentUnitGigaBytes: ' GB',
	CommonAttachmentModelId: 'Attachment model',
	CommonAttachmentTypeId: 'Attachment type',
	CommonAttachmentAllMarket: 'All Markets',
	CommonAttachmentMarketId: 'Market',
	CommonAttachmentShared: 'Shared',
	CommonAttachmentImage: 'Image',
	CommonAttachmentMergedCaption: 'Merged caption',
	CommonAttachmentCustomerId: 'Customer #',
	CommonAttachmentCustomerCode: 'Customer code',
	CommonAttachmentCustomerName: 'Customer caption',
	CommonAttachmentTradenameId: 'Tradename #',
	CommonAttachmentTradenameCode: 'Tradename code',
	CommonAttachmentTradenameCaption: 'Tradename caption',
	CommonAttachmentPurchaseGroupId: 'Purchase Group #',
	CommonAttachmentPurchaseGroupCode: 'Purchase Group code',
	CommonAttachmentPurchaseGroupCaption: 'Purchase Group caption',
	CommonAttachmentCircuitId: 'Circuit #',
	CommonAttachmentCircuitCode: 'Circuit code',
	CommonAttachmentCircuitCaption: 'Circuit caption',
	CommonAttachmentWarehouseId: 'Warehouse #',
	CommonAttachmentWarehouseCode: 'Warehouse code',
	CommonAttachmentWarehouseCaption: 'Warehouse caption',
	CommonAttachmentCustomerGroupId: 'Customer group #',
	CommonAttachmentCustomerGroupCode: 'Customer group code',
	CommonAttachmentCustomerGroupCaption: 'Customer group caption',
	CommonAttachmentSectorId: 'Sector #',
	CommonAttachmentSectorCode: 'Sector code',
	CommonAttachmentSectorCaption: 'Sector caption',
	CommonAttachmentProductId: 'Product #',
	CommonAttachmentProductCode: 'Product code ',
	CommonAttachmentProductCaption: 'Product caption',
	CommonAttachmentTrademarkId: 'Trademark #',
	CommonAttachmentTrademarkCode: 'Trademark code',
	CommonAttachmentTrademarkCaption: 'Trademark caption',
	CommonAttachmentSegmentationId: 'Segmentation #',
	CommonAttachmentSegmentationCode: 'Segmentation code',
	CommonAttachmentSegmentationCaption: 'Segmentation Caption',
	CommonAttachmentProductGroupId: 'Product group #',
	CommonAttachmentProductGroupCode: 'Product group code',
	CommonAttachmentProductGroupCaption: 'Product group caption',
	CommonAttachmentVisitId: 'Visit #',
	CommonAttachmentVisitDate: 'Visit Date',
	CommonAttachmentVisitDataTypeId: 'Order type',
	CommonAttachmentLinearId: 'Shelf #',
	CommonAttachmentOrderId: 'Order #',
	CommonAttachmentReportId: 'Report #',
	CommonAttachmentOfferId: 'Offer #',
	//CommonAttachmentOfferParentId: 'Parent Offer #',
	CommonAttachmentOfferCaption: 'Offer Caption',
	CommonAttachmentOfferActive: 'Offer active',
	CommonAttachmentOfferVisible: 'Offer visible',
	CommonAttachmentOfferMatplv: 'Offer MATPLV',
	CommonAttachmentOfferThemeCaption: 'Offer theme caption',
	CommonAttachmentOfferStateCaption: 'Offer status caption',
	CommonAttachmentOfferDeliveryStartDate: 'Offer delivery start date',
	CommonAttachmentOfferOperationStartDate: 'Offer Operation start Date',
	CommonAttachmentOfferVisitStartDate: 'Offer visit start date',
	CommonAttachmentOwnerId: 'Owner id',
	CommonAttachmentOwnerCode: 'Owner code',
	CommonAttachmentOwnerFirstName: 'Owner first name',
	CommonAttachmentOwnerLastName: 'Owner last name',
	CommonAttachmentFeedbackId: 'Feedback #',
	CommonAttachmentFeedbackCaption: 'Feedback Caption',
	CommonAttachmentFeedbackTypeId: 'Feedback Type',
	CommonAttachmentPostId: 'Post #',
	CommonAttachmentPostIsPrivate: 'Private Post',
	CommonAttachmentGridFilters: 'Attachment grid filters',
	CommonAttachmentGridMaximize: 'Maximize attachments grid',
	CommonAttachmentGridDelete: 'Delete attachment',
	CommonAttachmentGridDeleteConfirmation: 'Do you really want to delete the selected attachment?',
	CommonAttachmentGridExports:'Attachments exports',
	CommonAttachmentGridMassDelete: 'Mass delete',
	CommonAttachmentGridMassDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>ALL</u></b> displayed attachments tagged "to remove".<br>Do you want to continue deleting?',
	CommonAttachmentDeletePending: 'To delete',
	CommonAttachmentGridMassupdate: 'Mass update common attachments data',

	CommonAttachmentAttachmentGroupField: 'Attachment',
	CommonAttachmentCustomerGroupField: 'Customer',
	CommonAttachmentProductGroupField: 'Product',
	CommonAttachmentVisitGroupField: 'Visit',
	CommonAttachmentOfferGroupField: 'Offers',
	CommonAttachmentOwnerGroupField: 'Owner',
	CommonAttachmentFeedbackGroupField: 'Feedback',

	CommonAttachmentQuickInsertPlaceHolder: 'Add attachment',

	AttachmentDiaporamaOpenProductSection: 'Open product card',
	AttachmentDiaporamaOpenCustomerSection: 'Open customer card',
	AttachmentDiaporamaOpenOfferSection: 'Open offer card',
	AttachmentDiaporamaOpenVisitSection: 'Open visit',
	AttachmentDiaporamaOpenOrderSection: 'Open order',
	AttachmentDiaporamaVisitTitleFormat: 'Visit of {0}',
	AttachmentDiaporamaLinearTitleFormat: 'Shelf of {0}',
	AttachmentDiaporamaCRVTitleFormat: 'Report of {0}',
	AttachmentDiaporamaOrderTitleFormat: 'Order of {0}',
	AttachmentDiaporamaFileProperty: 'File',
	AttachmentDiaporamaSizeProperty: 'Size',
	AttachmentDiaporamaTypeProperty: 'Type',
	AttachmentDiaporamaDescriptionProperty: 'Description',
	AttachmentDiaporamaCustomerProperty: 'Customer',
	AttachmentDiaporamaOperationStartDateProperty: 'Starting on',
	AttachmentDiaporamaShottingDateProperty: 'Shotting date',
	AttachmentDiaporamaShottingDeviceProperty: 'Shotting device',
	AttachmentDiaporamaShottingGPSCoordinatesProperty: 'Shotting GPS (DMS)',
	AttachmentDiaporamaShottingGPSDistanceWithCustomer: 'Approximate distance to the customer',

	AttachmentModelProduct: 'Product',
	AttachmentModelCustomer: 'Customer',
	AttachmentModelOffer: 'Offers',
	AttachmentModelVisit: 'Visit',
	AttachmentModelVisitReport: 'Visit report',
	AttachmentModelLinear: 'Shelf',
	AttachmentModelOrder: 'Order',
	AttachmentModelTradename: 'Tradename',
	AttachmentModelTrademark: 'Trademark',
	AttachmentModelWarehouse: 'Warehouse',
	AttachmentModelCircuit: 'Circuit',
	AttachmentModelSegmentation: 'Segmentation',
	AttachmentModelPurchaseGroup: 'Purchase group',
	AttachmentModelCustomerGroup: 'Customer group',
	AttachmentModelProductGroup: 'Product group',
	AttachmentModelUser: 'User',
	AttachmentModelFeedback: 'Feedback',
	AttachmentModelPost: 'Post',

	AttachmentOptionSeeCustomerTradename: 'See customer tradename attachments',
	AttachmentOptionSeeCustomerPurchaseGroup: 'See customer purchase group attachments',
	AttachmentOptionSeeCustomerCustomerGroup: 'See customer group attachments',
	AttachmentOptionSeeCustomerCircuit: 'See customer circuit attachments',
	AttachmentOptionSeeCustomerWarehouse: 'See customer warehouse attachments',
	AttachmentOptionSeeCustomerVisits: 'See customer visits attachments',
	AttachmentOptionSeeCustomerLinears: 'See customer shelves attachments',
	AttachmentOptionSeeCustomerOrders: 'See customer orders attachments',
	AttachmentOptionSeeCustomerVisitReports: 'See customer visit reports attachments',
	AttachmentOptionSeeCustomerFeedbacks: 'See customer feedbacks attachments',
	AttachmentOptionSeeCustomerFeedbacksPosts: 'See customer feedback posts attachments',
	AttachmentOptionSeeVisitLinear: 'See visit shelf attachments',
	AttachmentOptionSeeVisitVisitReport: 'See visit visit report attachments',
	AttachmentOptionSeeVisitOrders: 'See visit orders attachments',
	AttachmentOptionSeeAllLinears: 'See all shelves attachments',
	AttachmentOptionSeeAllVisitReports: 'See all visit reports attachments',
	AttachmentOptionSeeAllOrderSameType: 'See all order same type attachments in visit',
	AttachmentOptionSeeAllOrderSameTypeInAllVisits: 'See all order same type attachments in all visits',
	AttachmentOptionSeeOfferOrder: 'See offer order attachments ',
	AttachmentOptionSeeTradenameCustomers: 'See tradename customer attachments',
	AttachmentOptionSeeTradenameCustomerGroup: 'See tradename customer group attachments',
	AttachmentOptionSeeTrademarkProducts: 'See trademark product attachments',
	AttachmentOptionSeeTrademarkProductGroup: 'See tradename customer group attachments',
	AttachmentOptionSeePurchaseGroupCustomerGroup: 'See purchase group customer group attachments',
	AttachmentOptionSeeSegmentationProductGroup: 'See segmentation product group attachements',
	AttachmentOptionSeeProductSegmentation: 'See product segmentation attachments',
	AttachmentOptionSeeProductTrademark: 'See product trademark attachments',
	AttachmentOptionSeeProductProductGroup: 'See product group attachments',
	AttachmentOptionSeeCustomerGroupTradenames: 'See customer group tradenames attachments',
	AttachmentOptionSeeCustomerGroupPurchaseGroups: 'See customer group purchase groups attachments',
	AttachmentOptionSeeCustomerGroupCustomers: 'See customer group customers attachments',
	AttachmentOptionSeeProductGroupTrademarks: 'See product group trademarks attachments',
	AttachmentOptionSeeProductGroupSegmentations: 'See product group segmentations attachments',
	AttachmentOptionSeeProductGroupProducts: 'See product group products attachments',
	AttachmentOptionSeeFeedbackPosts: 'See posts attachments',

	LayoutItemAttachmentAdd: 'Add attachment',
	LayoutItemAttachmentAddPopinTitle: 'Select attachment(s) to add',
	LayoutItemAttachmentSearch: 'Search attachments',
	LayoutItemAttachmentSearchPlaceholder: 'Search',
	LayoutItemAttachmentOpen: 'Open attachment',
	LayoutItemAttachmentDelete: 'Delete attachment',
	LayoutItemAttachmentBook: 'Attachment Book',
	LayoutItemAttachmentGrid: 'Attachment Grid',
	LayoutItemAttachmentFavorites: 'Attachment Favorites',
	LayoutItemAttachmentGridFailedToLoad: 'Failed to load attachments data',
	LayoutItemAttachmentGridExport: 'Export attachments data',
	LayoutItemAttachmentGridDownload: 'Download attachment(s)',

	ContextAttachmentGridFilters: 'Attachments grid filters',
	ContextAttachmentGridZoomIn: 'See more',
	ContextAttachmentGridZoomOut: 'See less',
	ContextAttachmentGridDeleteConfirmation: 'Do you really want to delete attachment "{0}"?',
	ContextAttachmentGridSaveSuccess: 'Attachments were saved',
	ContextAttachmentGridSaveFailed: 'Failed to save attachments',
	ContextAttachmentGridMaximize: 'Maximize attachments grid',

	CommonAttachmentEditPopinAddTitle: 'Adding attachment',
	CommonAttachmentEditPopinEditTitle: 'Editing attachment',
	CommonAttachmentEditPopinSelectionModel: 'Adding attachment to:',
	CommonAttachmentEditPopinCodeTypeSearchLabel: 'Code',
	CommonAttachmentEditPopinCaptionTypeSearchLabel: 'Caption',
	CommonAttachmentSaveSuccess: 'Attachment was saved',
	CommonAttachmentSaveFailed: 'Failed to save attachment',
	CommonAttachmentAskOverride: 'Do you really want to override this file {0}?',
	CommonAttachmentUploadFileSizeLimit: 'File size must be less than {0} bytes',
	CommonAttachmentPhotoFileName: 'photo_{0}_{1}.JPG',
	CommonAttachmentNoAccessToCamera: 'no access to camera',
	CommonAttachmentImageRotate: 'Rotate clockwise',

	/****** *Calendar ********/
	LayoutItemCalendar: 'Calendar',
	LayoutItemCalendarAvailablePeriods: 'Available periods',
	LayoutItemCalendarPeriodParam: 'Period',
	LayoutItemCalendarPeriodDay: 'Day',
	LayoutItemCalendarPeriodWeek: 'Week',
	LayoutItemCalendarPeriodWorkedWeek: 'Worked week',
	LayoutItemCalendarPeriodFullWeek: 'Full week',
	LayoutItemCalendarPeriodMonth: 'Month',
	LayoutItemCalendarTypeParam: 'Calendar type',
	LayoutItemCalendarTypeExpenses: 'Expenses',
	LayoutItemCalendarTypeActivity: 'Activity',
	LayoutItemCalendarTypePlanner: 'Planner',
	LayoutItemCalendarEventProperties: 'Visible event properties',
	LayoutItemCalendarAutoSizeParam: 'Event size based on it\'s duration',
	LayoutItemCalendarShowEditIcon: 'Show customer edit icon',
	LayoutItemCalendarNavigateBackward: 'Previous period',
	LayoutItemCalendarNavigateForward: 'Next period',
	LayoutItemCalendarPeriodControl: 'Date selection',
	LayoutItemCalendarViewControl: 'View selection',
	LayoutItemCalendarUserControl: 'User selection',
	LayoutItemCalendarAutoSaveViewParam: 'Automatically save view',
	LayoutItemCalendarEventDeleteConfirmation: 'Do you really want to delete the event?',
	LayoutItemCalendarDayDeleteConfirmation: 'Do you really want to delete events of the {0} ?',
	LayoutItemCalendarWeekDeleteConfirmation: 'Do you really want to delete events of the week from {0} to {1}',
	LayoutItemCalendarSynchronize: 'Synchronize with my office calendar',
	LayoutItemCalendarExports: 'Calendar export',
	LayoutItemCalendarMaximize: 'Maximize calendar',
	LayoutItemCalendarViewNotAvailable: 'Default period not available',
	LayoutItemCalendarRunTourOptimizer: 'Run route optimization',
	LayoutItemCalendarShowGhostEvents: 'Full view',
	LayoutItemCalendarHideGhostEvents: 'Compact view',
	LayoutItemCalendarCheckTimesAndDistances: 'Check times and distances',
	LayoutItemCalendarEventDeleteResult: '{0}/{1} events could be deleted',
	LayoutItemCalendarEventDeleteErrorMessage: 'Events could not be deleted',

	/***** Evenement en fiche *****/
	EventFormEdit: 'Edit event',
	EventFormLoadingError: 'An error occurred while loading data',

	/******* Planner *******/
	PlannerEventsUserId: 'User ID',
	PlannerEventsCreator: 'Event owner',
	PlannerEventsPrivateEvent: 'Private',
	PlannerEventsDone: 'Done',
	PlannerEventsPriority: 'Priority',
	PlannerEventsLockEvent: 'Locked',
	PlannerEventsCaption: 'Caption',
	PlannerEventsType: 'Event type',
	PlannerEventsCustomer: 'Customer',
	PlannerEventsDuration: 'Duration',
	PlannerEventsDate: 'Date',
	PlannerEventsAllDay: 'All day',
	PlannerEventsStart: 'Start',
	PlannerEventsEnd: 'End',
	PlannerEventsStartDate: 'Start date',
	PlannerEventsEndDate: 'End date',
	PlannerEventsStartTime: 'Start time',
	PlannerEventsEndTime: 'End time',
	PlannerEventsAtTime: 'at',
	PlannerEventsTo: 'to',
	PlannerEventsPlace: 'Place',
	PlannerEventsCode: 'Code',
	PlannerEventsParticipants: 'Attendees',
	PlannerEventsContacts: 'Contact(s)',
	PlannerEventsRelations: 'Relation(s)',
	PlannerEventsAddCustomerContact: 'Add customer contact',
	PlannerEventsAddRelation: 'Add guest',
	PlannerEventsAvailable: 'available',
	PlannerEventsNotAvailable: 'not available',
	PlannerEventsComments: 'Note',
	PlannerEventsUrl: 'Url',
	PlannerEventsNoAccessCustomer: 'Unable to access selected customer',
	PlannerEventsNoCustomerError: 'Please select a customer',
	PlannerEventsNoAccessDate: 'Cannot create event at this date',
	PlannerEventsNoStartDate: 'Please select a start date',
	PlannerEventsWrongDatetimes: 'End Date should be after Start Date',
	PlannerEventsCreateMultiEvents: 'Creation of {0} events',
	PlannerEventsAddRecurrence: 'Create recurrence',
	PlannerEventsRecurrence: 'Recurrence',
	PlannerEventsRecurrenceStartDate: 'From',
	PlannerEventsRecurrenceEndDate: 'Until',
	PlannerEventsRecurrenceRepeatEach: 'Repeat each',
	PlannerEventsRecurrenceWorkingDays: 'worked days',
	PlannerEventsRecurrenceWeekly: 'weeks',
	PlannerEventsRecurrenceMonthly: 'months',
	PlannerEventsInvalidRecurrencePeriod: 'The recurrence frequency must be greater than 1',
	PlannerEventsRecurrencePeriodExceedOneYear: 'The recurrence frequency exceed one year',

	PlannerEventsEditAdd: 'Add an event',
	PlannerEventsEditMenu: 'Edit...',
	PlannerEventsEditEvent: 'Edit event',
	PlannerEventsEditCustomer: 'Edit customer',
	PlannerEventsDeleteMenu: 'Delete ...',
	PlannerEventsDeleteEvent: 'Delete event',
	PlannerEventsDeleteDay: 'Delete day',
	PlannerEventsDeleteWeek: 'Delete week',
	PlannerEventsCopyEvent: 'Copy event',
	PlannerEventsCopyDay: 'Copy day',
	PlannerEventsCopyWeek: 'Copy week',
	PlannerEventsCutEvent: 'Cut event',
	PlannerEventsCutDay: 'Cut day',
	PlannerEventsCutWeek: 'Cut week',
	PlannerEventsPasteSelection: 'Paste selection',
	PlannerEventsAddEventOrVisitMenu: 'Add event / visit',
	PlannerEventsCreateVisit: 'Create visit',
	PlannerEventsOpenDayVisit: 'Open day visit',
	PlannerEventsNextEventsCustomer: 'Next events with current customer',
	PlannerEventsCreateEvent: 'Create new event',
	PlannerEventsExistingEvents: 'Existing events for selected date',
	PlannerEventsNoExistingEvents: 'No events exist for selected date',
	PlannerEventsNoSelection: 'Please select an event',
	PlannerEventsSpecialDayFound: 'Special days concerned by copy/cut action:',
	PlannerEventsTypeNotFound: 'Event type not available',
	PlannerEventsTypeUnknown: 'Unknown type',
	PlannerEventsAddEventSuccess: 'Event(s) added successfully',
	PlannerEventsAddMultipleEventsConfirmation: '<b>WARNING!</b> You are about to create <b>{0}</b> events in the planner.<br>Do you want to continue?',
	PlannerEventsAddMultipleEventsLimitationErrorMessage: 'Multiple add in the planner is limited to {0} elements',

	PlannerSynchronizationModalTitle: 'Synchronization',
	PlannerSynchronizationCancelButton: 'Cancel',
	PlannerSynchronizationValidateButton: 'Validate',
	PlannerSynchronizationUpdateCredentialLabel: 'Update connection information',
	PlannerSynchronizationUsernamePlaceholder: 'Username',
	PlannerSynchronizationPasswordPlaceholder: 'Password',
	PlannerSynchronizationError: 'Unexpected error during calendar synchronization',
	PlannerSynchronizationConnectException: 'Connection problem. Please check your settings again.',
	PlannerSynchronizationUnexpectedProviderException: 'External planner not supported: {0}',
	PlannerSynchronizationSuccess: 'Save completed.',

	PlannerComputeJourneysMissingLonLat: 'Missing longitude/latitude',
	PlannerComputeJourneysUserStartOfDayEventCaption: 'Home',
	PlannerComputeJourneysMissingGeoApiIdentifiers: 'Appkey and apptoken missing to connect to the geoAPI',
	PlannerComputeJourneysMissingCustomerCoordinates: 'Missing coordinates for customer {0}',
	PlannerComputeJourneysWarning: 'There is not enough time to go to the next event: {3} missing for the trip from {0} to {1} (estimated to be {2})',
	PlannerComputeJourneysNoWarning: 'All journey times are consistent with the times of events.',
	PlannerComputeJourneyErrorMessage: 'Error when calculating journey times',
	PlannerComputeJourneyBadKeyCodeErrorMessage: 'Bad key code ?',

	JourneyContextHandlerErrorMessageRetrievingJourneys: 'An error occured while retrieving journeys',

	ActivityGrid: 'Activity grid',
	ActivityGridEventsOnly: 'Events only',
	ActivityGridPeriod: 'Period',
	ActivityGridOpenVisit: 'Open visit',
	ActivityGridCreateVisit: 'Create visit',
	ActivityGridFieldsLabel: 'Fields labels',
	ActivityGridVisitPrepa: 'Visit preparation',
	ActivityGridMaximize: 'Maximize activity grid',

	ExpensePopinTitle: 'Expenses of ',
	ExpensePopinEditTitle: 'Title',
	ExpensePopinEditDescription: 'Description (optional)',
	ExpensePopinEditHT: 'Excl tax (€)',
	ExpensePopinEditTTC: 'Incl tax (€)',
	ExpensePopinEditAddExpense: 'Add an expense in {0}',
	ExpensePopinEditTotal: 'Expense total',
	ExpensePopinError: 'Save error for expenses',
	ExpensePopinBeforeCorrection: 'Value before correction: {0}',

	PlannerPopinTitleNew: 'New event',

	Activity: {
		sections: {
			kilometers: 'Kilometers',
			towns: 'Cities',
			times: 'Time',
			breaks: 'Break',
			hotel: 'Hotel',
			comment: 'Comment',
			carbonFootprint: 'Carbon Footprint'
		},
		fields: {
			startKilometers: 'Start km',
			endKilometers: 'End km',
			privateKilometers: 'Perso km',
			kilometers: 'Pro km',
			totalKilometers: 'Total Km',
			hotel: 'Hotel',
			comment: 'Comment',
			startTown: 'Start town',
			endTown: 'End town',
			startTime: 'Start time',
			endTime: 'End time',
			startBreak: 'Start break',
			endBreak: 'End break',
			optimalCo2: 'Optimal CO2 (g)',
			optimalDistance: 'Optimal distance (km)',
			optimalTravelTime: 'Optimal travel time (s)'
		},
		popin: {
			title: 'Activity of ',
			error: 'An error occurred. Activity may not be saved',
			requiredError: 'Please fill out all required fields',
			startAtLastEnd: 'Start with last known input'
		}
	},

	GisActionZoomIn: 'Zoom in',
	GisActionZoomOut: 'Zoom out',
	GisActionAdjust: 'Fit to content',
	GisActionMultiSelectMode: 'Rectangular selection',
	GisActionLegend: 'Legend',
	GisActionCustomerFilters: 'Customers map filters',
	GisActionMaximize: 'Maximize the map',

	ReportExportPopinTitle: 'Report export options',
	ReportExportPopinType: 'Format',
	ReportExportPopinCSVType: 'CSV (Comma separated text file)',
	ReportExportPopinXLSType: 'XLS (Excel 97 file)',
	ReportExportPopinXLSXType: 'XLSX (Excel 2007 file)',
	ReportExportPopinCharset: 'Charset',
	ReportExportPopinCharsetCP1252: 'CP1252 (plays nice with Excel)',
	ReportExportPopinCharsetISO88591: 'ISO-8859-1 (works like SOLVNet v1)',
	ReportExportPopinCharsetUTF8: 'UTF-8 (supports international characters)',
	ReportExportPopinMode: 'Mode',
	ReportExportPopinTableMode: 'Table',
	ReportExportPopinReportMode: 'Report',
	ReportExportPopinOptions: 'Options',
	ReportExportPopinFullOption: 'Expand all first',
	ReportExportPopinWithTotalsOption: 'Export totals and sub-totals',
	ReportExportPopinValidate: 'Start export',

	/** ---------- Product ---------- */
	ProductId: 'Product ID',
	ProductTrademarkId: 'Trademark',
	ProductSegmentation: 'Segmentation',
	ProductSegmentationXId: 'Segmentation {0}',
	ProductEan: 'Product EAN',
	ProductCode: 'Product Code',
	ProductCaption: 'Product Name',
	ProductShortCaption: 'Short Name',
	ProductBarCode: 'Product bar code',
	ProductRefImage: 'Image',
	ProductRefImageView: 'Product image (view)',
	ProductRefImageSmall: 'Image small',
	ProductRefImageSmallView: 'Small image product (view)',
	ProductInactive: 'Inactive',
	ProductLength: 'Length (mm)',
	ProductHeight: 'Height (mm)',
	ProductDepth: 'Depth (mm)',
	ProductPcb: 'PCB',
	ProductTva: 'VAT',
	ProductSrp: 'Break-even point',
	ProductPvc: 'RRP',
	ProductPa: 'Unit price',
	ProductPcbPa: 'PCB Price',
	ProductWeight: 'Weight',
	ProductPcbWeight: 'PCB Weight',
	ProductVolume: 'Volume',
	ProductPcbVolume: 'PCB Volume',
	ProductStockLimit: 'Stock Limit',
	ProductComment: 'Comment',
	ProductExtractDate: 'Product extract date',
	ProductProvisionSDate: 'Provision start date',
	ProductProvisionEDate: 'Provision end date',
	ProductInno: 'Product Inno',
	ProductTop: 'Top product',
	ProductCreateDate: 'Product create date',
	ProductUpdateDate: 'Product update date',
	ProductAttachment: 'Product attachment',
	ProductAttachmentDescription: 'Product attachment description',
	ProductAttachmentType: 'Product attachment type',
	ProductAttachmentAllMarket: 'Product attachment all market',
	ProductPackagingDisplay: 'Packaging',
	ProductPackagingTotalPa: 'Packaging Total Price',
	ProductPackagingTotalSrp: 'Packaging Total break-even point',
	ProductPackagingTotalPvc: 'Packaging Total RRP',
	ProductPackagingTotalQuantity: 'Packaging Total Quantity',
	ProductPackagingTotalWeight: 'Packaging Total Weight in mg',
	ProductPackagingTotalVolume: 'Packaging Total Volume in mm3',
	ProductPackagingTotalPcbPa: 'Packaging Total Price (PCB)',
	ProductPackagingTotalPcbSrp: 'Packaging Total break-even point (PCB)',
	ProductPackagingTotalPcbPvc: 'Packaging Total RRP (PCB)',
	ProductPackagingTotalPcbQuantity: 'Packaging Total Quantity (PCB)',
	ProductPackagingTotalPcbWeight: 'Packaging Total Weight in mg (PCB)',
	ProductPackagingTotalPcbVolume: 'Packaging Total Volume in mm3 (PCB)',
	ProductBigImage: 'Big image indicator',
	ProductDeletePending: 'To delete',

	ProductNewCaption: 'New product',

	ProductGridFailedToLoad: 'Failed to load products data',
	ProductGridDeleteConfirmation: 'Do you really want to delete the selected product?',
	ProductGridOpen: 'Open',
	ProductGridCreate: 'Create',
	ProductGridCopy: 'Copy',
	ProductGridDelete: 'Delete selected item',
	ProductGridProductFilter: 'Filter on current item',
	ProductGridProductFilterOnProductGroup: 'Product Group',
	ProductGridProductFilterOnTrademark: 'Trademark',
	ProductGridProductFilterOnSegmentation: 'Segmentation',
	ProductGridMassdelete: 'Remove selected items',

	ProductFormFailedToLoad: 'Failed to load product data',
	ProductFormSaveSuccess: 'Product saved',
	ProductFormSaveFailed: 'Failed to save product',
	ProductGridExports: 'Products exports',
	ProductGridFilters: 'Products filters',
	ProductGridMassUpdate: 'Mass update products data',
	ProductGridMaximize: 'Maximize product grid',

	ProductSelectPopinTitle: 'Product selection',

	ProductRestoreConfirmMessage: 'A deleted product ({0}) used the code {1}, do you wish to restore it?',
	ProductMessageErrorCodeAlreadyUsed: 'Code already used, delete it to reuse it',
	ProductMessageErrorCodeAlreadyUsedDeleted: 'Code already used but deleted, create it to reuse it',

	ProductPackagingProductId: 'Id',
	ProductPackagingQuantity: 'Quantity',

	ProductPackagingGridFailedToLoad: 'Failed to load products packaging',
	ProductPackagingGridSaveSuccessMessage: 'Packaging saved',
	ProductPackagingGridSaveFailedMessage: 'Failed to save product packaging',
	ProductPackagingGridSaveFailedQuantityIsEmpty: 'Please complete the quantity for product {0}',
	ProductPackagingGridDeleteConfirmation: 'Do you really want to delete the selected packaging?',
	ProductPackagingGridFilters: 'Packaging grid filters',
	ProductPackagingAddProducts: 'Add',
	ProductPackagingRemoveProduct: 'Remove product',
	ProductPackagingGridMaximize: 'Maximize packaging grid',

	ProductPackagingFailedToLoad: 'Packaging failed to load',

	ProductPackagingPopinTitle: 'Restocking',
	ProductPackagingPopinValidate: 'Validate',

	/** -----------External Files ----*/
	DatasharingAdd: 'Add entry',
	DatasharingEdit: 'Update entry',
	DatasharingDelete: 'Delete entry',
	DatasharingExport: 'Export',
	DatasharingExportPopinTitle: 'File export',
	DatasharingExportPopinMode: 'Start export',
	DatasharingExportPopinModeOrigin: 'with the original file format',
	DatasharingExportPopinModeCustom: 'with a customized file format',
	DatasharingExportPopinOptions: 'Options',
	DatasharingExportPopinWithHeaders: 'Generate header row',
	DatasharingExportPopinValidate: 'Export',
	DatasharingKeyInvalid: 'Key is invalid',
	DatasharingKeyAlreadyExist: 'External file key already exist',
	DatasharingKeyConfirmDelete: 'A record with that key already exist, do you confirm deletion?',
	DatasharingKeyConfirmEraseAndUpdate: 'Keys for that record are to be updated, do you confirm?',
	DatasharingFailedToLoad: 'Failed to load the external file',
	DatasharingGridInsertFailed: 'Failed to insert a new  entry',
	DatasharingGridUpdateFailed: 'Failed to update the entry',
	DatasharingGridDeleteFailed: 'Failed to delete the entry',
	DatasharingGridDeleteConfirmation: 'Do you really want to delete the selected entry?',
	DatasharingGridSaveFailed: 'Failed to save external file entry',
	DatasharingGridMaximize: 'Maximize external files grid',

	/** ---------- Imports ---------- */
	ImportMarketCaption: 'Market Caption',
	ImportCustomerId: 'Customer ID',
	ImportCustomerCode: 'Customer Code',
	ImportCustomerEan: 'Customer Ean',
	ImportPurchaseGroup1Caption: 'Purchase Group 1 Caption',
	ImportPurchaseGroup2Caption: 'Purchase Group 2 Caption',
	ImportPurchaseGroup3Caption: 'Purchase Group 3 Caption',
	ImportPurchaseGroup4Caption: 'Purchase Group 4 Caption',
	ImportPurchaseGroup5Caption: 'Purchase Group 5 Caption',
	ImportPurchaseGroup6Caption: 'Purchase Group 6 Caption',
	ImportPurchaseGroup7Caption: 'Purchase Group 7 Caption',
	ImportPurchaseGroup8Caption: 'Purchase Group 8 Caption',
	ImportPurchaseGroup9Caption: 'Purchase Group 9 Caption',
	ImportPurchaseGroup1Code: 'Purchase Group 1 Code',
	ImportPurchaseGroup2Code: 'Purchase Group 2 Code',
	ImportPurchaseGroup3Code: 'Purchase Group 3 Code',
	ImportPurchaseGroup4Code: 'Purchase Group 4 Code',
	ImportPurchaseGroup5Code: 'Purchase Group 5 Code',
	ImportPurchaseGroup6Code: 'Purchase Group 6 Code',
	ImportPurchaseGroup7Code: 'Purchase Group 7 Code',
	ImportPurchaseGroup8Code: 'Purchase Group 8 Code',
	ImportPurchaseGroup9Code: 'Purchase Group 9 Code',
	ImportCircuit1Caption: 'Circuit 1 Caption',
	ImportCircuit2Caption: 'Circuit 2 Caption',
	ImportCircuit1Code: 'Circuit 1 Code',
	ImportCircuit2Code: 'Circuit 2 Code',
	ImportProductId: 'Product ID',
	ImportProductCode: 'Product Code',
	ImportProductEan: 'Product EAN',
	ImportTradenameCode: 'Tradename Code',
	ImportTradenameCaption: 'Tradename Caption',
	ImportProductSegment1Caption: 'Segmentation 1 Caption',
	ImportProductSegment2Caption: 'Segmentation 2 Caption',
	ImportProductSegment3Caption: 'Segmentation 3 Caption',
	ImportProductSegment4Caption: 'Segmentation 4 Caption',
	ImportProductSegment5Caption: 'Segmentation 5 Caption',
	ImportProductSegment6Caption: 'Segmentation 6 Caption',
	ImportProductSegment1Code: 'Segmentation 1 Code',
	ImportProductSegment2Code: 'Segmentation 2 Code',
	ImportProductSegment3Code: 'Segmentation 3 Code',
	ImportProductSegment4Code: 'Segmentation 4 Code',
	ImportProductSegment5Code: 'Segmentation 5 Code',
	ImportProductSegment6Code: 'Segmentation 6 Code',
	ImportWarehouseCode: 'Warehouse Code',
	ImportWarehouseCaption: 'Warehouse Caption',
	ImportTrademarkCode: 'Trademark Code',
	ImportTrademarkCaption: 'Trademark Caption',
	ImportUserLogin: 'UserLogin',
	ImportCustomerUserLogin: 'Customer User Login',
	ImportUserCode: 'User Code',
	ImportSectorCode: 'Secteur Code',
	ImportOfferId: 'Offer ID',
	ImportOfferCode: 'Offer Code',
	ImportVisitId: 'Visit ID',
	ImportVisitCode: 'Visit Code',
	ImportLinearId: 'Shelf ID',
	ImportLinearCode: 'Shelf Code',
	ImportOrderId: 'Order ID',
	ImportOrderCode: 'Order Code',
	ImportThemeId: 'Theme ID ',
	ImportThemeCode: 'Theme Code',
	ImportCreateDate: 'Create Date',
	ImportUpdateDate: 'Update Date',
	ImportUpdateUserId: 'Updated by',
	// les champs génériques de l'import
	ImportGenericString: 'Text',
	ImportGenericInteger: 'Integer',
	ImportGenericFloat: 'Float',
	ImportGenericBoolean: 'Boolean',
	ImportGenericDate: 'Date',
	ImportGenericDateDimension: 'Date (dimension)',
	ImportGenericMonth: 'Month',
	ImportGenericYear: 'Year',
	ImportGenericDateTime: 'Date/time',

	/** ------- Grille dernier relevé linéaire du client -------- */
	LastLinearGridFailedToLoad: 'Failed to load last customer shelf data input',
	LastLinearGridPleaseSelectConfiguration: 'Please select a configuration',
	LastLinearGridFilters: 'Last shelf grid filters',
	LastLinearGridMaximize: 'Maximize last shelf grid',

	/** ------- Offer Grid -------- */
	OfferHeaderDepth: 'Depth',
	OfferHeaderId: '#',
	OfferHeaderParentId: 'Parent',
	OfferHeaderActive: 'Active',
	OfferHeaderVisible: 'Visible',
	OfferHeaderCreateUserId: 'Created by',
	OfferHeaderCreateDate: 'Creation date',
	OfferHeaderUpdateUserId: 'Update by',
	OfferHeaderUpdateDate: 'Update date',
	OfferHeaderStateId: 'Status offer',
	OfferHeaderStateColumn: 'Status {0}',
	OfferHeaderStateUpdateDate: 'Status update date',
	OfferHeaderCode: 'Code',
	OfferHeaderCaption: 'Caption',
	OfferHeaderComments: 'Comments',
	OfferHeaderVisitDataTypeId: 'Type',
	OfferHeaderThemeId: 'Theme',
	OfferHeaderMatplv: 'MATPLV',
	OfferHeaderAttachment: 'Offer attachment',
	OfferHeaderOperationSDate: 'Operation start date',
	OfferHeaderOperationEDate: 'Operation end date',
	OfferHeaderVisitSDate: 'Visit start date',
	OfferHeaderVisitEDate: 'Visit end date',
	OfferHeaderDeliverySDate: 'Delivery start date',
	OfferHeaderDeliveryEDate: 'Delivery end date',
	OfferHeaderTrademarkId: 'Offer trademark',
	OfferHeaderRestrictProduct: 'Restrict offer product',
	OfferHeaderCustomerScopeId: 'Customer scope',
	OfferHeaderCustomerTradenames: 'Tradenames',
	OfferHeaderCustomerWarehouses: 'Warehouses',
	OfferHeaderPurchaseGroupId: 'Purchase group {0}',
	OfferHeaderCustomerPurchaseGroups: 'Purchase groups',
	OfferHeaderCircuitId: 'Circuit {0}',
	OfferHeaderCustomerCircuits: 'Circuits',
	OfferHeaderSegmentationId: 'Segmentation {0}',
	OfferHeaderDeletePending: 'To delete',
	OfferHeaderMeanId: 'Mean',
	OfferGridMany: 'Many',
	OfferGridFailedToLoad: 'Failed to load offers',
	OfferPeriod: 'Search period',
	OfferRangeOperationDate: 'Operation date range',
	OfferRangeVisitDate: 'Visit date range',
	OfferRangeDeliveryDate: 'Delivery date range',
	OfferTypes: 'Types',
	OfferFilter: 'Filter',
	OfferTypePopinTitle: 'Select a type',
	OfferTypePopinValidate: 'Validate',
	ActiveOfferGridFailedToLoad: 'Active offers failed to load',
	ActiveOfferGridFilter: 'Filter on active offers',
	ActiveOfferGridFilterOnCurrentPeriod: 'Filter on current period',
	ActiveOfferGridCustomerFilter: 'Filter on current customer item',
	ActiveOfferGridCustomerFilterOnCustomer: 'Customer',
	ActiveOfferGridCustomerFilterOnCustomerGroup: 'Customer group',
	ActiveOfferGridCustomerFilterOnPurchaseGroup: 'Purchase group',
	ActiveOfferGridCustomerFilterOnTradename: 'Tradename',
	ActiveOfferGridProductFilter: 'Filter on current product item',
	ActiveOfferGridProductFilterOnProduct: 'Product',
	ActiveOfferGridProductFilterOnTrademark: 'Trademarque',
	ActiveOfferGridProductFilterOnSegmentation: 'Segmentation',
	ActiveOfferGridProductFilterOnProductGroup: 'Product group',
	ActiveOfferGridLoadWithoutWaitContextSelection: 'Load without wait the selection',
	ActiveOfferGridOpen: 'Open offer',
	ActiveOfferGridExport: 'Export offer',
	ActiveOfferGridMaximize: 'Maximize active offer grid',

	/** -------Offer Header Grid -------- */
	OfferHeaderGridFailedToLoad: 'Offer failed to load',
	OfferHeaderGridMenuAddToolTip: 'Add / Copy',
	OfferHeaderGridAdd: 'Add an offer',
	OfferHeaderGridAddChild: 'Add an offer to {0}({1})',
	OfferHeaderGridCopy: 'Copy an offer',
	OfferHeaderGridOpen: 'Open offer',
	OfferHeaderGridDelete: 'Delete the selected offer',
	OfferHeaderGridExports: 'Export the offer',
	OfferHeaderGridFilters: 'Filter on offers',
	OfferHeaderGridMaximize: 'Maximize offer grid',
	OfferHeaderGridMassUpdate: 'Mass update offers data',
	OfferHeaderGridDeleteConfirmation: 'Do you really want to delete the selected offer?',
	OfferHeaderCopyLabel: 'Copy of {0}',

	/** -------Offer Form -------- */
	OfferFailedToLoad: 'Erreur de chargement de la promotion',

	/** -------Offer Detail Grid -------- */
	OfferDetailProductsQuickInsertPlaceHolder: 'Add product',
	OfferDetailProductAdd: 'Add a product',
	OfferDetailProductDelete: 'Delete a product',
	OfferDetailProductOpen: 'Open product form',
	OfferDetailProductsGridFilters: 'Offer products filters',
	OfferDetailProductsDeleteNoUsedProducts: 'Delete no longer available products',
	OfferDetailGridMaximize: 'Maximize offer products',
	OfferDetailFailedToLoad: 'Offer products failed to load',
	OfferDetailGridDeleteConfirmation: 'Do you really want to delete the selected product?',
	OfferDetailGroupField: 'Offer',
	OfferDetailProductGroupField: 'Product',

	OfferDetailUcPrice: 'Uc Price',
	OfferDetailPcbPrice: 'Pcb Price',
	OfferDetailUcQuantity: 'Uc Quantity',
	OfferDetailPcbQuantity: 'Pcb Quantity',
	OfferDetailFreeUcQuantity: 'Free Uc Quantity',
	OfferDetailFreePcbQuantity: 'Free Pcb Quantity',
	OfferDetailTotalUcQuantity: 'Total Uc Quantity',
	OfferDetailTotalPcbQuantity: 'Total Pcb Quantity',
	OfferDetailQtyDiscount1: 'Qty Discount 1',
	OfferDetailQtyDiscount2: 'Qty Discount 2',
	OfferDetailQtyDiscount3: 'Qty Discount 3',
	OfferDetailQtyDiscount: 'Discount',
	OfferDetailPctDiscount1: 'Pct Discount 1',
	OfferDetailPctDiscount2: 'Pct Discount 2',
	OfferDetailPctDiscount3: 'Pct Discount 3',
	OfferDetailPctDiscount: 'Pct Discount',
	OfferDetailValDiscount1: 'Val Discount 1',
	OfferDetailValDiscount2: 'Val Discount 2',
	OfferDetailValDiscount3: 'Val Discount 3',
	OfferDetailValDiscount: 'Val Discount',
	OfferDetailNegociatedPrice: 'Negociated Price',
	OfferDetailOfferTypeIds: 'Offer Types',
	OfferDetailValidated: 'Validated',
	OfferDetailNoConform: 'NoConform',

	/** -------Typology Grid -------- */
	TypologyId: 'Id',
	TypologyCode: 'Code',
	TypologyVisible: 'Actif',
	TypologyValidated: 'Validated',
	TypologyCaption: 'Caption',
	TypologyComments: 'Comments',
	TypologyStartDate: 'Application start date',
	TypologyEndDate: 'Application end date',
	TypologyDescentStartDate: 'Cascading start date',
	TypologyDescentEndDate: 'Cascading end date',
	TypologyWithoutDepth: 'Without depth',
	TypologyUnvalidatedBySynchro: 'Unvalidated by synchro.',
	TypologyCustomerId: 'Customer',
	TypologyTradenameId: 'Tradename',
	TypologyWarehouseId: 'Warehouse',
	TypologyPurchaseGroupId: 'Purchasegroup',
	TypologyPurchaseGroup1Id: 'Purchasegroup 1',
	TypologyPurchaseGroup2Id: 'Purchasegroup 2',
	TypologyPurchaseGroup3Id: 'Purchasegroup 3',
	TypologyPurchaseGroup4Id: 'Purchasegroup 4',
	TypologyPurchaseGroup5Id: 'Purchasegroup 5',
	TypologyPurchaseGroup6Id: 'Purchasegroup 6',
	TypologyPurchaseGroup7Id: 'Purchasegroup 7',
	TypologyPurchaseGroup8Id: 'Purchasegroup 8',
	TypologyPurchaseGroup9Id: 'Purchasegroup 9',
	TypologyUpdateDate: 'Update date',
	TypologyUpdateUserId: 'Modify by',
	TypologyDeletePending: 'To delete',

	TypologyGridFailedToLoad: 'Failed to load typologies data',
	TypologyGridDeleteConfirmation: 'Do you really want to delete the selected typology?',
	TypologyGridDeleteFailed: 'Failed to delete typology',
	TypologyGridSaveSuccess: 'Typology saved',
	TypologyGridSaveFailed: 'Failed to save typology',
	TypologyGridAdd: 'Add typology',
	TypologyGridCopy: 'Copy typology',
	TypologyGridOpen: 'Open typology',
	TypologyGridDelete: 'Delete the selected typology',
	TypologyGridFilters: 'Typologies filters',
	TypologyGridMaximize: 'Maximize typology grid',
	TypologyGridOutOfScopeMessage: 'Typology is out of configuration\'s scope',
	TypologyGridDeletePending: 'To delete',
	TypologyGridMassDelete: 'Delete all selected typologies',
	TypologyGridMassDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>ALL</u></b> displayed typologies tagged "to remove".<br>Do you want to continue deleting?',
	TypologyGridMassUpdate: 'Mass update typology',

	/** -------Typology Detail Grid -------- */
	TypologyProductCodeTypo: 'Typo product code',
	TypologyProductSegmentationTypo: 'Typo product segmentation',
	TypologyApplicationStartDate: 'Application start date',
	TypologyApplicationEndDate: 'Application end date',
	TypologyCustomerActive: 'Active',
	TypologyCustomerComment: 'Comment',
	TypologyLevelActive: 'Level {0}',
	TypologyLevelComment: 'Comment {0}',
	TypologyStartLevel: 'Start level',

	TypologyTypologyGroupField: 'Typology',
	TypologyProductGroupField: 'Product',

	TypologyDetailProductOpen: 'Open form product',
	TypologyDetailAdd: 'Add product',
	TypologyDetailDelete: 'Remove product',
	TypologyDetailDeleteNoUsedProducts: 'Delete no longer available products',
	TypologyDetailGridFilters: 'Typology products filters',
	TypologyDetailGridMaximize: 'Maximize typology products grid',

	TypologyDetailGridDeleteConfirmation: 'Do you really want to delete the selected product in the typology?',
	TypologyDetailProductsQuickInsertPlaceHolder: 'Add product',

	TypologyCopyLabel: 'Copy of {0}',
	TypologyFailedToLoad: 'Failed to load typology data',
	TypologyOutOfConfig: 'Typology out of configuration',
	TypologyGridExports: 'Export typology',
	TypologyGridValidateAll: 'Validate all',

	/** ------- Univers ------- **/
	PopinCustomerScope: 'Scope',
	PopinCustomerScopeCustomers: 'Customers',
	PopinCustomerScopeTradenames: 'Tradenames',
	PopinCustomerScopePurchaseGroups: 'Purchases groups',
	PopinCustomerScopeCircuits: 'Circuits',
	PopinCustomerScopeWarehouses: 'Warehouses',
	PopinCustomerScopeSectors: 'Sector',
	PopinCustomerScopeOthers: 'Others',
	PopinCustomerScopeLoadFailed: 'Failed to load',

	/** Analysis  **/
	AnalysisCompileFailed: 'Compile failed',

	/** Import **/
	ImportId: 'ID',
	ImportActive: 'Active',
	ImportCaption: 'Caption',
	ImportFilename: 'File',
	ImportMode: 'Mode',
	ImportModel: 'Model',
	ImportMarket: 'Market',
	ImportModelParam: 'Type',
	ImportFileType: 'File type',
	ImportDate: 'Last import',
	ImportPath: 'File path',
	ImportDateSuffix: 'Date suffixed',
	ImportDateFormat: 'Date Format',
	ImportTimeFormat: 'Time Format',
	ImportArchive: 'Archive',
	ImportInsertOnly: 'Insert only',
	ImportEditable: 'Editable',
	ImportEditableKey: 'Editable key',
	ImportCharset: 'Encoding',
	ImportGroupSeparator: 'Group separator',
	ImportDecimalSeparator: 'Decimal separator',
	ImportLineSeparator: 'Carriage return',
	ImportFieldSeparator: 'Field separator',
	ImportFieldWrapper: 'Field wrapper',

	ImportModels: 'Import models',
	ImportModelCustomer: 'Customer',
	ImportModelProduct: 'Product',
	ImportModelContact: 'Contact',
	ImportModelTypology: 'Typology',
	ImportModelPrice: 'Price',
	ImportModelCatchmentArea: 'Catchment areas',
	ImportModelGeneric: 'Data-sharing',
	ImportModelLinear: 'Shelf',
	ImportModelOrder: 'Order',
	ImportModelOffer: 'Offer',
	ImportModelPlanner: 'Planner',
	ImportModelVisitReport: 'Visit report',
	ImportModelCustomerTypology: 'Customer typologies',
	ImportModelCustomerMemo: 'Customer notes',
	ImportModelAttachment: 'Attachment',
	ImportModelExpense: 'Expense',
	ImportModelUser: 'User',
	ImportModelFeedback: 'Feedback',

	ImportModeUpdate: 'Update',
	ImportModeCancelReplace: 'Cancel/Replace',

	ImportGroupSeparatorNone: 'None',
	ImportGroupSeparatorSpace: 'Space',

	ImportFieldSeparatorTab: 'Tab',

	ImportFieldWrapperNone: 'None',

	ImportGridExecuteImport: 'Execute import',
	ImportGridFilter: 'Imports filters',
	ImportGridMaximize: 'Maximize import grid',

	ImportSuccessMessage: 'File {0} imported',
	ImportErrorMessageAnOtherImportAlreadyInProgress: 'Import cannot process. A Task is already in progress. Please retry later',
	ImportErrorMessageUnexpected: 'Unexpected error',
	ImportConfirmOverwrite: 'A file already existing. Please confirm overwrite',
	ImportUploadSuccessMessage: 'Upload success',

	/** Export **/
	ExportId: 'ID',
	ExportActive: 'Active',
	ExportCaption: 'Caption',
	ExportFilename: 'File',
	ExportMode: 'Mode',
	ExportModel: 'Model',
	ExportMarket: 'Market',
	ExportModelParam: 'Type',
	ExportDate: 'Last export',
	ExportBeginDate: 'Begin date',
	ExportEndDate: 'End date',
	ExportVisibleHeaders: 'Active Data',
	ExportNewOnly: 'New only',
	ExportUpdatedOnly: 'Updated',
	ExportHeader: 'Headers',
	ExportExtractMark: 'Mark',
	ExportLastReport: 'Last report',
	ExportDateSuffix: 'Date suffix',
	ExportDateFormat: 'Date Format',
	ExportTimeFormat: 'Time Format',
	ExportGroupSeparator: 'Group separator',
	ExportDecimalSeparator: 'Decimal separator',
	ExportLineSeparator: 'Carriage return',
	ExportFieldSeparator: 'Field separator',
	ExportFieldWrapper: 'Field wrapper',
	ExportFileType: 'File type',
	ExportPath: 'File path',
	ExportFormula: 'Formula', // 'Formel', // '',
	ExportVisitReportFilterGroup: 'Group filter', // 'Filter Rubrik', // '',
	ExportVisitReportFilterState: 'State filter', // 'Filter Status', // '',
	ExportCustomerScope: 'Customer scope', // 'Kundenuniversum', // '',
	ExportProductScope: 'Product scope', // 'Produktuniversum', // '',

	ExportGroupSeparatorNone: 'None',
	ExportGroupSeparatorSpace: 'Space',

	ExportFieldSeparatorTab: 'Tab',

	ExportFieldWrapperNone: 'None',

	ExportModeComplete: 'Complete',
	ExportModeHeader: 'Headers',
	ExportModeDetails: 'Details',

	ExportModels: 'Export models',
	ExportModelCustomer: 'Customer',
	ExportModelProduct: 'Product',
	ExportModelContact: 'Contact',
	ExportModelTypology: 'Typology',
	ExportModelPrice: 'Price',
	ExportModelVisit: 'Visit',
	ExportModelLinear: 'Shelf',
	ExportModelOrder: 'Order',
	ExportModelOffer: 'Offers',
	ExportModelPlanner: 'Planner',
	ExportModelExpense: 'Expense',
	ExportModelVisitReportInLine: 'Visit report in line',
	ExportModelVisitReportInColumn: 'Visit report in column',
	ExportModelCustomerTypology: 'Customer typologies',
	ExportModelCustomerMemo: 'Customer notes',
	ExportModelAttachment: 'Attachment',
	ExportModelAttachmentFile: 'Attachment file',
	ExportModelUser: 'User',
	ExportModelFeedback: 'Feedback',

	ExportGridExecuteExport: 'Execute export',
	ExportGridFilter: 'Exports filters',
	ExportGridMaximize: 'Maximize export grid',

	ExportSuccessMessage: 'File {0} exported',
	ExportErrorMessageAnOtherExportAlreadyInProgress: 'Export cannot process. An import is already in progress. Please retry later',

	/* Notifications */
	PopinNotifications: 'Notifications',
	NotificationVisitOf: 'Visit of {0}',
	NotificationUnvalidVisit: 'This visit isn\'t valid. Please validate it',
	NotificationVisit: 'Open visite',
	NotificationTypology: 'Typologies',
	NotificationTypologyInConflict: 'Typologies are in conflict on the market {0}.',
	NotificationTypologyOpen: 'Open the typologies page',
	NotificationMails: 'Mails',
	NotificationMailsError: 'An error occured and one mail could not be sent. Use the button to check the configuration.',
	NotificationMailsErrors: 'Some errors occured and {0} mails could not be sent. Use the button to check the configuration.',
	NotificationMailsOpen: 'Check the configuration',
	NotificationMessageOf: '{0} shared a message with you',
	NotificationSharePageOpen: 'Open the share page',
	NotificationSharePageCancel: 'Delete the notification of the share page',
	NotificationDeletionFailed: 'An error occured during deletion of the notification.',
	NotificationMailServerHeader: 'Check e-mail service',
	NotificationMailServerOff: 'E-mail service\'s start is locked by an environment variable',
	NotificationMailServerStop: 'E-mail service is stopped',
	NotificationMailServerConnectionFailed: 'E-mail service is stopped. Connection to SMTP server failed',
	NotificationMailServerSmtpNotConfigured: 'E-mail service is not configured',
	NotificationPasswordExpirationHeader: 'Password expiration',
	NotificationPasswordExpiration: 'Password will expire in {0} day(s)',

	/* Upload template */
	TemplateFailedToLoad: 'Failed to load template data',
	TemplateDeleteFailed: 'Failed to delete',
	TemplateUploadFailed: 'Failed to upload',
	TemplateDownload: 'Download template',
	TemplateAdd: 'Add template',
	TemplateDelete: 'Delete template',
	TemplateConfirmOverwrite: 'A file already existing. Please confirm overwrite',

	/* GanttChart plan promotionnel */
	PlanningOfferGanttChartOpenOffer: 'Open offer',
	PlanningOfferGanttChartMaximize: 'Maximize planning offer',
	PlanningOfferGanttChartParamGroupLabel: 'Tradename or trademark and offer caption',
	PlanningOfferGanttChartUnspecifiedLabel: 'Unspecified',
	PlanningOfferGanttChartFilterByGroupLabel: 'Filter by group',
	PlanningOfferGanttChartFromToDateLabel: 'from {0} to {1}',
	PlanningOfferGanttChartFromDateLabel: 'from {0}',
	PlanningOfferGanttChartUntilDateLabel: 'until {0}',
	PlanningOfferGanttChartEmptyRangeDateLabel: 'Empty value',
	PlanningOfferGanttChartSegmentationLabel: 'Segmentation',
	PlanningOfferGanttChartTrademarkLabel: 'Trademark',
	PlanningOfferGanttChartPurchaseGroupsLabel: 'Purchase groups',
	PlanningOfferGanttChartTradenamesLabel: 'Tradenames',
	PlanningOfferGanttChartFailedToLoad: 'Failed to load planning offer',
	PlanningOfferGanttChartOfferFailedToLoad: 'Failed to load offer datas',
	PlanningOfferGanttChartFilterLabel: 'Offers filter',

	/* Champs de formulaire utilisables dans différents contexte */
	FormCharset: 'Encoding',
	FormDateFormat: 'Date Format',
	FormTimeFormat: 'Time Format',
	FormDecimalSeparator: 'Decimal separator',
	FormThousandSeparator: 'Thousand separator',
	FormThousandSeparatorNone: 'None',
	FormThousandSeparatorSpace: 'Space',
	FormFieldSeparator: 'Field separator',
	FormFieldSeparatorTab: 'Tab',
	FormFieldWrapper: 'Field wrapper',
	FormFieldWrapperNone: 'None',
	FormLineSeparator: 'Line separator',

	/* En-tête client */
	CustomerHeaderLastVisitDate: 'Last visit',
	CustomerHeaderNextEventDate: 'Next event',
	CustomerHeaderAvailabilities: 'Availabilities',
	CustomerHeaderParamHideLastVisitDate: 'Hide last visit date',
	CustomerHeaderParamHideNextEventDate: 'Hide next event date',
	CustomerHeaderParamHideAvailabilities: 'Hide availabilities',

	/* Grille des mémos des clients */
	CustomersMemosGridDelete: 'Delete selected memo',
	CustomersMemosGridDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>the selected memo</u></b>.<br>Do you confirm the deletion?',
	CustomersMemosGridFilterLabel: 'Filter memos',
	CustomersMemosGridMassDelete: 'Delete all selected memos',
	CustomersMemosGridMassDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>ALL</u></b> displayed memos tagged "to remove".<br>Do you want to continue deleting?',
	CustomersMemosGridMaximize: 'Maximize memo grid',
	CustomersMemosGridFailedToLoad: 'Failed to load memo list',
	CustomersMemosGridFailedToSave: 'Failed to save memos',
	CustomersMemosGridCustomerGroupField: 'Customer',
	CustomersMemosGridMemoGroupField: 'Memo',
	CustomersMemosMarket: 'Market',
	CustomersMemosDeletePending: 'To delete',
	CustomersMemosGridMassUpdate: 'Mass update memos data',

	/* Grille des contacts des clients */
	CustomersContactsGridDelete: 'Delete selected contact',
	CustomersContactsGridDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>the selected contact</u></b>.<br>Do you want to continue deleting?',
	CustomersContactsGridFilterLabel: 'Filter contacts',
	CustomersContactsGridMassDelete: 'Delete all selected contacts',
	CustomersContactsGridMassDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>ALL</u></b> displayed contacts tagged "to remove".<br>Do you want to continue deleting?',
	CustomersContactsGridMaximize: 'Maximize contact grid',
	CustomersContactsGridFailedToLoad: 'Failed to load contact list',
	CustomersContactsGridFailedToDelete: 'Failed to delete contacts',
	CustomersContactsGridCustomerGroupField: 'Customer',
	CustomersContactsGridContactGroupField: 'Contact',
	CustomersContactsGridMassUpdate: 'Mass update contacts data',

	/* Grille des suivis client */
	FeedbackId: 'Feedback id',
	FeedbackCustomerId: 'Customer',
	FeedbackMarketId: 'Marché',
	FeedbackDateOfCare: 'Date of care',
	FeedbackStatusId: 'Status',
	FeedbackStatusComments: 'Status comments',
	FeedbackStatusDate: 'Status date',
	FeedbackStatusUserId: 'Status user',
	FeedbackPriorityId: 'Priority',
	FeedbackAffectedToId: 'Affected to',
	FeedbackReportedById: 'Reported by',
	FeedbackTypeId: 'Type',
	FeedbackCaption: 'Caption',
	FeedbackDueDate: 'Due date',
	FeedbackDurationOfIntervention: 'Duration of intervention',
	FeedbackCreateDate: 'Create date',
	FeedbackCreateUserId: 'Created by',
	FeedbackUpdateDate: 'Update date',
	FeedbackUpdateUserId: 'Updated by',
	FeedbackPublication: 'Publication',
	FeedbackPublicationTo: 'Published to',
	FeedbackDurationInHours: 'Duration (in hours)',
	FeedbackLastModificationDate: 'Last update date',
	FeedbackLastModificationUserId: 'Last updated by',
	FeedbackDeletePending: 'To delete',

	FeedbackGridFailedToLoad: 'Failed to load feedbacks data',
	FeedbackGridDeleteConfirmation: 'Do you really want to delete the selected feedback?',
	FeedbackGridDeleteFailed: 'Failed to delete feedback',
	FeedbackGridSaveSuccess: 'Feedback saved',
	FeesbackGridSaveFailed: 'Failed to save feedback',
	FeedbackGridOpen: 'Open',
	FeedbackGridStatus: 'Change status',
	FeedbackGridMail: 'Send a mail',
	FeedbackGridReport: 'Send a feedback report',
	FeedbackGridExports: 'Feedback export',
	FeedbackGridDelete: 'Delete the selected feedback',
	FeedbackGridCreate: 'Create feedback',
	FeedbackGridCustomerQuickSelectPlaceHolder: 'Customer name',
	FeedbackGridSearch: 'Search input',
	FeedbackGridSearchPlaceholder: 'Search...',
	FeedbackGridCheckDuration: 'Check spent time',
	FeedbackGridFilters: 'Feedbacks filters',
	FeedbackGridMaximize: 'Maximize feedback grid',
	FeedbackGridOutOfScopeMessage: 'Feedback is out of configuration\'s scope',
	FeedbackGridMassDelete: 'Delete all selected feedbacks',
	FeedbackGridMassDeleteConfirmation: '<b>WARNING!</b><br>You are going to delete <b><u>ALL</u></b> displayed feedbacks tagged "to remove".<br>Do you want to continue deleting?',
	FeedbackGridMassUpdate: 'Mass update feedback data',

	FeedbackFailedToLoad: 'Failed to load feedback data',
	FeedbackOutOfConfig: 'Feedback out of configuration',

	FeedbackMailSubject: 'Feedback # {0}: {1}{2}',
	FeedbackMailContent: 'Hello,<br>Please find attached the evolution of the {0}.<br>We remain at your disposal to answer all your questions.<br><br>Regards,<br><br>{1}',
	FeedbackReportContent: 'Hello,<br>Please find below the thread of the feedback #{0}: {1}{2}.<br>We remain at your disposal to answer all your questions.<br><br>Regards,<br><br>{3}',
	FeedbackReportFeedback: 'Feedback',
	FeedbackReportCustomer: 'Society',
	FeedbackReportStatus: 'Status',
	FeedbackReportDate: 'Creation date',
	FeedbackReportPostHeader: '{0} on {1}',

	FeedbackPostAdd: 'Add post',
	FeedbackPostAddTime: 'Add spent time',
	FeedbackPostEdit: 'Edit post',
	FeedbackPostDelete: 'Delete post',
	FeedbackPostMaximize: 'Maximize discussion thread',
	FeedbackPostFailedToAdd: 'Failed to add post',
	FeedbackPostPrivateLabel: 'Private message',
	FeedbackPostPublicLabel: 'Public message',

	PostDeleteConfirmation: 'Do you really want to delete the selected post?',
	PostEditPopinTitle: 'Edit post',
	PostEditPopinPrivateLabel: 'Private message',
	PostEditPopinDurationLabel: 'Duration (in hours)',
	PostEditPopinInsertImage: 'Insert the image in the text',
	PostEditPopinInsertLink: 'Insert a link to the file in the text',
	PostDurationPopinTitle: 'Spent time edition',
	PostDurationPopinPrevDate: 'Previous day',
	PostDurationPopinNextDate: 'Next day',
	PostDurationPopinAddFeedback: 'Search for feedback...',
	PostDurationPopinDurationColumn: 'Spent time (h)',
	PostDurationPopinDayTotal: 'Total time spent on day',
	PostDurationPopinWeekTotal: 'Total time spent on week',

	ActiveOfferGanttChartFailedToLoad: 'Failed to load gantt chart active offer',

	GlobalSearchPlaceHolder: 'Search...',
	
	BackToTopLabel: 'Back to the top',
	
	/* Grille des cubes */
	CubeId: '#',
	CubeCaption: 'Caption',
	CubeDescription: 'Description',
	CubeVisible: 'Visible',
	CubeCanCreate: 'Create',
	CubeRefreshDate: 'Refreshed on',

	CubeNew: 'New Cube',
	CubeDeleteConfirmation: 'Do you really delete the cube and all its reports?',
	CubeGridImportConfirmation:'Cubes data importation may take some time. Do you want to start import?',
	CubeGridAdd: 'Add cube',
	CubeGridDelete: 'Delete cube',
	CubeGridCompile: 'Compile cubes',
	CubeGridCleanAndCompile: 'Clean and compile cubes',
	CubeGridLogs: 'Download compilation logs',
	CubeGridFilters: 'Cubes filters',
	CubeGridMaximize: 'Maximize cubes grid',
	CubeGridDataMapping: 'Data mapping',

	// Pattern grid
	CubePatternId: 'ID',
	CubePatternActive: 'Active',
	CubePatternCaption: 'Caption',
	CubePatternCubeType: 'Type',
	CubePatternStatus: 'Status',
	CubePatternRefreshDate: 'Refreshed on',
	CubePatternPeriodType: 'Period',
	CubePatternPeriodStart: 'Begin date',
	CubePatternPeriodEnd: 'End date',
	CubePatternPeriodDuration: 'Duration',
	CubePatternCountLimit: 'Statement count',
	CubePatternByMarket: 'By market',
	CubePatternMarkets: 'Markets',
	CubePatternPeriodSplit: 'Period split',
	CubePatternReleveType: 'Statement type',
	CubePatternStatFile: 'Source file',
	CubePatternMultiOffer: 'Multi offer',
	CubePatternTargetDate: 'Target date',
	CubePatternPeriodBeforeStart: 'Time count before period',
	CubePatternUsed: 'Used in selected cube',
	CubePatternRowCount: 'Row count',
	CubePatternCompilationTime: 'Compilation time',

	CubePatternCubeTypeExternalData: 'External file',
	CubePatternCubeTypeLastLinears: 'Last shelves',
	CubePatternCubeTypeAllLinears: 'All shelves',
	CubePatternCubeTypeLinearRange: 'Shelf range',
	CubePatternCubeTypeOrders: 'Orders',
	CubePatternCubeTypeActiviteMarche: 'Market activity',
	CubePatternCubeTypeLastVisitsReports: 'Last visits reports',
	CubePatternCubeTypeAllVisitsReports: 'All visits reports',
	CubePatternCubeTypeOffer: 'Offers',
	CubePatternCubeTypeAgenda: 'Agenda',
	CubePatternCubeTypeNoteDeFrais: 'Expense',
	CubePatternCubeTypeProductLaunch: 'Product launch',
	CubePatternCubeTypeFilteredExternalData: 'Filtered external file',
	CubePatternCubeTypeReference: 'Referencement',
	CubePatternCubeTypeFeedback: 'Feedback',
	CubePatternCubeTypeTypologies: 'Typologies',
	CubePatternCubeTypeContact: 'Contact',
	
	CubePatternReleveTypeSOLVNET: 'Internal',
	CubePatternReleveTypeEXTERNAL: 'External',
	CubePatternReleveTypeBOTH: 'All',
	
	CubePatternPeriodSplitNONE: 'No split',
	CubePatternPeriodSplitSEMAINE: 'Week',
	CubePatternPeriodSplitMOIS: 'Month',
	CubePatternPeriodSplitBIMESTRE: 'Bimester',
	CubePatternPeriodSplitTRIMESTRE: 'Quarter',
	CubePatternPeriodSplitQUADRIMESTRE: 'Third-year',
	CubePatternPeriodSplitSEMESTRE: 'Half-year',
	CubePatternPeriodSplitANNEE: 'Year',
	CubePatternPeriodSplitCYCLE: 'Cycle',
	
	CubePatternPeriodTypeTOTAL: 'Total',
	CubePatternPeriodTypeFIXED: 'Fixed',
	CubePatternPeriodTypeFLOATING: 'Floating',
	
	CubePatternStatusNoData: 'Required external generation',
	CubePatternStatusNoUpdate: 'No available update',
	CubePatternStatusRequired: 'Required SolvNet compilation',
	CubePatternStatusUnknown: 'Undefined update status',
	CubePatternStatusAvailable: 'Available update',
	
	CubePatternGridAdd: 'Add cube pattern',
	CubePatternGridCopy: 'Copy cube pattern',
	CubePatternGridCompile: 'Compile cube pattern',
	CubePatternGridDelete: 'Delete cube pattern',
	CubePatternGridFilters: 'Cube patterns filters',
	CubePatternGridMaximize: 'Maximize cube patterns grid',
	CubePatternCopyLabel: 'Copy of {0},',
	
	CubeContentWhatSee: 'See',
	CubeContentWhatSeeBoth: 'Levels and measures',
	CubeContentLevelsLabel: 'Levels',
	CubeContentMeasuresLabel: 'Measures',
	CubeContentAttributesButtonLabel: 'Attributes',
	CubeContentRemoveButtonLabel: 'Remove',
	CubeContentPlaceHolder: 'Add...',
	CubeContentMaximize: 'Maximize cube content',
	CubeContentInfoLabel: 'Please select a cube and a source to view / edit the content',

	CubePatternDeleteConfirmation: 'Do you really delete the source and all its affiliations in the cubes?',

	// Grille des tâches scheduler
	TaskGridAdd: 'Add task',
	TaskGridEdit: 'Edit task',
	TaskGridRun: 'Run the task',
	TaskGridStop: 'Stop the task',
	TaskGridStopConfirmation: 'Do you really want to stop the task? This may last few moments',
	TaskGridDelete: 'Delete task',
	TaskGridTriggerMenu: 'Triggers',
	TaskGridAddTrigger: 'Add trigger',
	TaskGridTriggerMenuTrigger: 'Trigger {0}',
	TaskGridStartScheduler: 'Start scheduler',
	TaskGridStopScheduler: 'Stop scheduler',
	TaskGridStopSchedulerConfirmation: 'Do you really want to stop the scheduler?',
	TaskGridRefresh: 'Refresh',
	TaskGridRemoveEnded: 'Delete ended tasks',
	TaskGridDownloadLogs: 'Download scheduler log',
	TaskGridShowGraph: 'View tasks sequence',
	TaskGridTaskNumber: 'Task {0}',

	TaskGridFailedToLoad: 'Failed to load',
	TaskGridFailedToCreateTask: 'Failed to create task',
	TaskGridFailedToCreateTrigger: 'Failed to create trigger',
	TaskGridFailedSave: 'Failed to save',
	TaskGridFailedToDeleteTask: 'Failed to delete task',
	TaskGridFailedToDeleteTrigger: 'Failed to delete trigger',
	TaskGridFailedToRunTask: 'Failed to run the task',
	TaskGridFailedToRemoveEndedTasks: 'Failed to delete ended tasks',

	TaskId: 'Id',
	TaskType: 'Type',
	TaskCaption: 'Caption',
	TaskActive: 'Active',
	TaskLastExecution: 'Last execution',
	TaskLastExecutionStatus: 'Last status',
	TaskLastExecutionStatusIdle: 'Idle',
	TaskLastExecutionStatusRunning: 'Running',
	TaskLastExecutionStatusEnded: 'Ended',
	TaskLastExecutionStatusSuspended: 'Suspended',
	TaskLastExecutionStatusTimeOut: 'Timeout',
	TaskLastExecutionStatusError: 'Error',
	TaskLastExecutionStatusInterruptionInProgress: 'Interruption in progress',
	TaskAttemptTime: 'Execution time between 2 attemps',
	TaskAttemptCount: 'Maximum execution attempt number',
	TaskMaxExecutionMinutes: 'Maximum execution time',
	TaskProperties: 'Properties',
	TaskTriggers: 'Triggers',
	TaskTriggersOr: ' OR ',
	TaskExecutionStart: 'Execution begin',
	TaskExecutionEnd: 'Execution end',
	TaskLastExecutionUser: 'User',
	TaskLastExecutionUserScheduler: 'Scheduler',

	TaskDeleteConfirmation: 'Do you really want to delete a task?',
	TriggerDeleteConfirmation: 'Do You really want to delete a trigger?',

	// Popin d'édition de tâche
	TaskEditionPopinTitle: 'Task edition',
	TaskNew: 'New task',

	TaskTypeImportCubes: 'Compile BI cubes',
	TaskTypeImportFile: 'Import file',
	TaskTypeExportFile: 'Export file',
	TaskTypeExportReport: 'Export OLAP report',
	TaskTypeCleanBase: 'Clean database for date range',
	TaskTypeReportMeasureInCustomerExtendedInfo: 'Fill a customer information with a report\'s measure',
	TaskTypeExportReportTemplate: 'Export report template',
	TaskTypeControlParser: 'Execute some controls',
	TaskTypeExportOfferByMonth: 'Export offer list by month',
	TaskTypeExportEmail: 'Export mails',
	TaskTypeExportDatasharing: 'Export external file',
	TaskTypeExportCustomerByUser: 'Export customer list by user',
	TaskTypeCleanLogsAndImportedFiles: 'Clean log files and imported files',
	TaskTypeCopyFilesTo: 'Copy files to',
	TaskTypeTrace: 'Add trace message in logs',
	TaskTypeSendTaskSummary: 'Send execution report',

	TaskTypeImportCubesPropertyClean: 'Clean database',
	TaskTypeImportCubesPropertyClone: 'Activer database copy',
	TaskTypeImportCubesPropertyImportGeneric: 'Activate external files compilation',
	TaskTypeImportCubesPropertyIds: 'Cube patterns',

	TaskTypeImportFilePropertyFile: 'Imported file',
	TaskTypeExportFilePropertyFile: 'Exported file',

	TaskTypeExportReportPropertyReport: 'Report',
	TaskTypeExportReportPropertyDirectory: 'Export path',
	TaskTypeExportReportPropertyMode: 'Type',
	TaskTypeExportReportPropertyModeExcelReport: 'Excel report',
	TaskTypeExportReportPropertyModeExcelTable: 'Excel table',
	TaskTypeExportReportPropertyModeCsvReport: 'CSV table',
	TaskTypeExportReportPropertyModeFullExcelTable: 'Full Excel table',
	TaskTypeExportReportPropertyModeFullCsvTable: 'Full CSV table',
	TaskTypeExportReportPropertyModeFullExcelReport: 'Full Excel report',
	TaskTypeExportReportPropertyModeFullTableWithoutTotals: 'Full table without totals',
	TaskTypeExportReportPropertyModeFullCsvTableWithoutTotals: 'CSV table without totals',
	TaskTypeExportReportPropertyModeXslxReport: 'XSLX report',
	TaskTypeExportReportPropertyModeFullXlsxReport: 'Full XSLX report',
	TaskTypeExportReportPropertyModeXlsxTable: 'XSLX table',
	TaskTypeExportReportPropertyModeFullXlsxTable: 'Full XSLX table',
	TaskTypeExportReportPropertyModeXlsxTableWithoutTotals: 'XSLX table without totals',
	TaskTypeExportReportPropertyHuge: 'Huge export',
	TaskTypeExportReportPropertyEncoding: 'Encoding',

	TaskTypeCleanBasePropertyObjectId: 'Cleaning type',
	TaskTypeCleanBasePropertyObjectIdVisit: 'Visit',
	TaskTypeCleanBasePropertyObjectIdDatasharing: 'External files',
	TaskTypeCleanBasePropertyMarketId: 'Market',
	TaskTypeCleanBasePropertyDateFrom: 'Beginning date',
	TaskTypeCleanBasePropertyDateTo: 'Ending date',
	TaskTypeCleanBasePropertyIds: 'External files',
	TaskTypeCleanBasePropertyOlderThan: 'Number of months taken into account from the first day of the month of the processing date',

	TaskTypeReportMeasureInCustomerExtendedInfoPropertyReport: 'Report',
	TaskTypeReportMeasureInCustomerExtendedInfoPropertySourceName: 'Source',
	TaskTypeReportMeasureInCustomerExtendedInfoPropertyMeasureName: 'Measure',
	TaskTypeReportMeasureInCustomerExtendedInfoPropertyInfoId: 'Extended information',
	TaskTypeReportMeasureInCustomerExtendedInfoPropertyComputedMeasures: 'Calculated measures',

	TaskTypeExportReportTemplatePropertyDirectory: 'Export path',
	TaskTypeExportReportTemplatePropertyFile: 'Template',

	TaskTypeControlParserPropertyType: 'Control type',
	TaskTypeControlParserPropertyTypeVisit: 'Visit',
	TaskTypeControlParserPropertyTypeOrder: 'Order',
	TaskTypeControlParserPropertyTypeOffer: 'Offer',
	TaskTypeControlParserPropertyTypeLinear: 'Shelf',
	TaskTypeControlParserPropertyTypeReport: 'Report',
	TaskTypeControlParserPropertyTypeCustomer: 'Customer',
	TaskTypeControlParserPropertyTypeProduct: 'Product',
	TaskTypeControlParserPropertyTypeFeedback: 'Feedback',
	TaskTypeControlParserPropertyLevel: 'Level',
	TaskTypeControlParserPropertyLevelHeader: 'Header',
	TaskTypeControlParserPropertyLevelDetail: 'Detail',
	TaskTypeControlParserPropertyMarket: 'Market',
	TaskTypeControlParserPropertyLog: 'Activate logs',

	TaskTypeExportOfferByMonthPropertyMarket: 'Market',
	TaskTypeExportOfferByMonthPropertyDirectory: 'Export path',
	TaskTypeExportOfferByMonthPropertyFile: 'Generated filename',
	TaskTypeExportOfferByMonthPropertyCriteria: 'Criteria',
	TaskTypeExportOfferByMonthPropertyCriteriaOperationDate: 'Operation date',
	TaskTypeExportOfferByMonthPropertyCriteriaPassageDate: 'Passage date',
	TaskTypeExportOfferByMonthPropertyCriteriaDeliveryDate: 'Delivery date',
	TaskTypeExportOfferByMonthPropertyInfos: 'Information to generate',

	TaskTypeExportEmailPropertyDirectory: 'Export path',
	TaskTypeExportEmailPropertyDateFrom: 'Beginning date',
	TaskTypeExportEmailPropertyDateTo: 'Ending date',
	TaskTypeExportEmailPropertyInfos: 'Information to generate',

	TaskTypeExportDatasharingPropertyDirectory: 'Export path',
	TaskTypeExportDatasharingPropertyFile: 'File',
	TaskTypeExportDatasharingPropertyHeader: 'Generate headers',
	TaskTypeExportDatasharingPropertyOutput: 'Generated filename',

	TaskTypeExportCustomerByUserPropertyDirectory: 'Export path',
	TaskTypeExportCustomerByUserPropertyFile: 'File',
	TaskTypeExportCustomerByUserPropertySeparator: 'Separator',
	TaskTypeExportCustomerByUserPropertyMarketId: 'Market',
	TaskTypeExportCustomerByUserPropertyHeader: 'Generate headers',

	TaskTypeCleanLogsAndImportedFilesNumberOfDays: 'Number of days to keep',

	TaskTypeCopyFilesToSourceDirectory: 'Source directory',
	TaskTypeCopyFilesToTargetDirectory: 'Target directory',
	TaskTypeCopyFilesToDeleteContent: 'Delete files from source directory',

	TaskTypeTraceMessage: 'Message to trace',

	TaskComputeCarbonFootprint: 'Carbon footprint',
	TaskTypeComputeCarbonFootsprintPeriod: 'Period',
	TaskTypeComputeCarbonFootprintyUserIds: 'Users',
	TaskTypeComputeCarbonFootprintyClean: 'Clean out of period data',

	TaskTypeSendTaskSummaryTask: 'Task',
	TaskTypeSendTaskSummaryMailSettings: 'Mail settings',

	// Popin d'édition de déclencheur
	TriggerEditionPopinTitle: 'Trigger edition',
	TriggerNew: 'New trigger',
	TriggerCaption: 'Caption',
	TriggerType: 'Type',

	TriggerTypeDaily: 'Daily',
	TriggerTypeDailyMenuCaption: 'Everyday at {0}',
	TriggerTypeDailyTime: 'Time (HH:mm:ss)',
	TriggerTypeFileExists: 'File exists',
	TriggerTypeFileExistsMenuCaption: 'File {0} exists',
	TriggerTypeFileExistsFile: 'Expected file path',
	TriggerTypeAfterTask: 'After task',
	TriggerTypeAfterTaskMenuCaption: 'After task {0}',
	TriggerTypeAfterTaskSuccessMenuCaption: 'After task {0} succes',
	TriggerTypeAfterTaskErrorMenuCaption: 'After task {0} error',
	TriggerTypeAfterTaskTask: 'Task',
	TriggerTypeAfterTaskOnSuccess: 'Task ended successfully',
	TriggerTypeAfterTaskOnError: 'Task ended with error',
	TriggerTypeWeekly: 'Weekly',
	TriggerTypeWeeklyMenuCaption: 'At {0} on {1}',
	TriggerTypeWeeklyTime: 'Time (HH:mm:ss)',
	TriggerTypeWeeklyDayOfWeek: 'Days',
	TriggerTypeMonthly: 'Monthly',
	TriggerTypeMonthlyMenuCaption: 'The {0}st of the month at {1}',
	TriggerTypeMonthlyTime: 'Time (HH:mm:ss)',
	TriggerTypeMonthlyDayOfMonth: 'Day',
	TriggerTypeYearly: 'Yearly',
	TriggerTypeYearlyMenuCaption: 'On {0}/{1} at {2}',
	TriggerTypeYearlyTime: 'Time (HH:mm:ss)',
	TriggerTypeYearlyDayOfMonth: 'Day of month',
	TriggerTypeYearlyMonth: 'Month',
	TriggerTypeNMinutes: 'Period in minutes',
	TriggerTypeNMinutesMenuCaption: 'Every {0} minutes',
	TriggerTypeNMinutesMinutes: 'Interval',
	TriggerTypeManual: 'Manual',

	TaskGraphTitle: 'Task sequence',
	TaskGraphGridLayout: 'Grid',
	TaskGraphTreeLayout: 'Hierarchy',

	// Cartographie des données
	DataMappingOverlayTitle: 'Data mapping',
	DataMappingMeasureType: 'Measure',
	DataMappingLevelType: 'Level',
	DataMappingCalculationType: 'Calculation',
	DataMappingReportType: 'Report',
	DataMappingLayoutItemType: 'Page item',
	DataMappingCubePatternType: 'Source',
	DataMappingCubeType: 'Cube',
	DataMappingExternalFileType: 'External file',

	DataMappingMeasureNodeCaption: '{0}',
	DataMappingMeasureNodeContent: 'Measure ({0}) updated on {1}',
	DataMappingLevelNodeCaption: '{0}',
	DataMappingLevelNodeContent: 'Level',
	DataMappingCalculationNodeCaption: '{0}',
	DataMappingCalculationNodeContent: 'Calculation ({0})',
	DataMappingReportNodeCaption: '{0}',
	DataMappingReportNodeContent: 'Report ({0}, opened on {1})',
	DataMappingLayoutItemNodeCaption: 'Item {0} on page {1}',
	DataMappingLayoutItemNodeContent: 'Page item ({0})',
	DataMappingCubePatternNodeCaption: '{0}',
	DataMappingCubePatternNodeContent: 'Source updated on {0}',
	DataMappingCubeNodeCaption: '{0}',
	DataMappingCubeNodeContent: 'Compiled {0}',
	DataMappingUsedResources: 'Used resources',
	DataMappingNotUsedResources: 'Not used resources',
	DataMappingExternalFileNodeCaption: '{0}',
	DataMappingExternalFileNodeContent: 'External file ({0})',

	DataMappingGlobalSearchTitle: 'Global search',
	DataMappingTargetedSearchTitle: 'Targeted search',
	DataMappingSettingsTitle: 'Settings',
	DataMappingLegendTitle: 'Legend',
	DataMappingFormDataType: 'Data type',
	DataMappingFormCubeProperty: 'Cube',
	DataMappingFormSourceProperty: 'Source',
	DataMappingFormMeasureProperty: 'Measure',
	DataMappingFormLevelProperty: 'Level',
	DataMappingFormCalculationProperty: 'Calculation',
	DataMappingFormExternalFileProperty: 'File',
	DataMappingFormExecute: 'Execute',

	DataMappingSettingsFormHideAllUnused: 'Hide not used resources: ',
	DataMappingSettingsFormHideNotSelectedInBI: 'Hide unselected resources in BI configuration: ',
	DataMappingSettingsFormUsedLimitDays: 'Highlight resources not opened/updated since (days): ',

	DataMappingLegendWarnedResource: '<b>Highlighted resource</b>: </br>Report not opened since X* days, source or calculation not compiled since X days, page item not visible</br></br>* See settings',
	DataMappingLegendFinalResource: 'Final resource',

	DataMappingCsvMeasureColumn: 'Measure',
	DataMappingCsvUsedColumn: 'Used',
	DataMappingCsvSourceColumn: 'Source',
	DataMappingCsvLevelColumn: 'Level',
	DataMappingCsvCalculationColumn: 'Calculation',
	DataMappingCsvCubeColumn: 'Cube',
	DataMappingCsvCubesColumn: 'Cubes',
	DataMappingCsvInternalMeasureNameColumn: 'Internal measure name',
	DataMappingCsvInternalLevelNameColumn: 'Internal level name',
	DataMappingCsvInternalSourceNameColumn: 'Internal source name',
	DataMappingCsvCalculationIdColumn: 'Calculation Id',

	DataMappingErrorMessage: 'Sorry, an error occured',
	DataMappingRunningMessage: 'Running...',

	// Grille des adresses des utilisateurs
	LayoutItemUserAddressGrid: 'User addresses grid',
	LayoutItemUserAddressGridFailedToLoad: 'Failed to load user addresses',
	LayoutItemUserAddressGridFilters: 'User filters',
	LayoutItemUserAddressGridMaximize: 'Maximize user addresses grid',

	UserAddressUserId: 'User',
	UserAddressAddress: 'Address',
	UserAddressZipCode: 'Zip code',
	UserAddressCity: 'City',
	UserAddressState: 'State',
	UserAddressCounty: 'County',
	UserAddressCountry: 'Country',
	UserAddressDayStartTime: 'Day start time',
	UserAddressDayEndTime: 'Day end time',
	UserAddressLunchStartTime: 'Lunch start time',
	UserAddressLunchEndTime: 'Lunch end time',
	UserAddressReturnAtHome: 'Return at home',
	UserAddressUserAddressLat: 'Latitude',
	UserAddressUserAddressLon: 'Longitude',
	UserAddressDeleteGeocode: 'Delete lat/lon',
	UserAddressGeocode: 'Geocode',
	UserAddressTourOptimizer: 'Route optimization',
	UserVehicleFuelType: 'Fuel type',
	UserVehicleFuelTypeUnleadedFuel: 'Unleaded fuel',
	UserVehicleFuelTypeDiesel: 'Diesel',
	UserVehicleFuelTypeElectrical: 'Electrical',
	UserVehicleAverageConsumption: 'Average consumption',

	// Géocodage d'adresse
	GeocodeAddressFailedToLoad: 'Error while geocoding',
	GeocodeAddressValidate: 'Validate',
	GeocodeAddressAddressList: 'List of addresses',
	GeocodeAddressNoResults: 'No result',
	GeocodeAddressNote : "Note",
    GeocodeAddressType : "Type",
    GeocodeAddressNotFound : "Not found",
    GeocodeAddressAddressPoint : "Address Point",
    GeocodeAddressPOI : "POI",
    GeocodeAddressNamedPlace : "Names Place",
    GeocodeAddressCityPostCode : "City + PostCode",
    GeocodeAddressCity : "City",
    GeocodeAddressDistrictPostCode : "District + PostCode",
    GeocodeAddressDistrict : "District",
    GeocodeAddressStreet : "Street",
    GeocodeAddressZonePostCode : "Zone + PostCode",
    GeocodeAddressStreetNumberInterpolation : "Street Number Interpolation",
    GeocodeAddressStreetNumberBound : "Street Number Bound",
    GeocodeAddressStreetNumberEstimation : "Street Number Estimation",
    GeocodeAddressStreetNumberNearest : "Street Number Nearest",
    GeocodeAddressPonctualPostCode : "Ponctual PostCode",

	// Optimisation de tournée.
	TourOptimizerPopinTitle: 'Route optimization: {0}',
	TourOptimizerPopinUnrenseignedLabel: 'Empty items',
	TourOptimizerPopinPeriodLabel: 'Period',
	TourOptimizerPopinWorkTimeSlotSessionLabel: 'Work timewindow',
	TourOptimizerPopinPeriodToGenerateSessionLabel: 'Period to optimize',
	TourOptimizerPopinLunchSessionLabel: 'Lunch',
	TourOptimizerPopinTakeALunchBreakSessionLabel: 'Take a lunch break',
	TourOptimizerPopinLunchDuration: 'Duration',
	TourOptimizerPopinOptionsSessionLabel: 'Options',
	TourOptimizerPopinReturnAtHome: 'Return at home on day end',
	TourOptimizerPopinUseCustomerAvailabilities: 'Use customer availabilities',
	TourOptimizerPopinUseContactsAvailabilities: 'Use contacts availabilities',
	TourOptimizerPopinErrorMessageNoOrders: 'No planned events to optimize on the selected period.',

	TourOptimizerResumePopinVisitPlanned: 'Planned visits: {0}',
	TourOptimizerResumePopinMaxDistanceVisitPlanned: 'Max distance visit zone (km): {0}',
	TourOptimizerResumePopinVisitPlannedLocked: 'Locked visits ({0})',
	TourOptimizerResumePopinVisitPlannedUnlocked: 'Unlocked visits ({0})',
	TourOptimizerResumePopinVisitsNumber: '{0} visits',
	TourOptimizerResumePopinWarningZoneLabel: 'Warning',
	TourOptimizerResumePopinTooManyVisitInPeriodWarningLabel: 'More visiting time than working time available over the period.',
	TourOptimizerResumePopinMaxDistanceWarningLabel: 'If overnight stays are not allowed, the maximum distance from the starting point must be less than 500km',
	TourOptimizerResumePopinMaxCustomerDistanceWarningLabel: 'Maximum distance between two customers on the circuit is greater than 500 km.',

	TourOptimizerResultPopinVisitPlanned: 'Planned visits',
	TourOptimizerResultPopinVisitUnplanned: 'Unplanned visits',
	TourOptimizerResultPopinVisitTotalDistance: 'Total distance',
	TourOptimizerResultPopinTotalDriveTime: 'Total drive time',
	TourOptimizerResultPopinTotalWorkTime: 'Total work time',
	TourOptimizerResultPopinTotalRestTime: 'Total rest time',
	TourOptimizerResultPopinTotalWaitTime: 'Total wait time',
	TourOptimizerResultPopinTotalTourNumber: 'Total tour number',
	TourOptimizerResultPopinCancelMessage: 'Do you really want to quit and lose the optimization result?',

	TourOptimizerRunErrorMessage: 'Sorry, an error occured: {0}',
	TourOptimizerBadKeyCodeErrorMessage: 'Bad key code?',
	TourOptimizerSlowDownErrorMessage: 'Oups, slow down please.',
	TourOptimizerRunProgressionMessage: 'Waiting time 3 min max ({0})',

	LayoutItemCarbonFootprint: 'Carbon footprint',
	LayoutItemCarbonFootprintInformation: 'Data',
	LayoutItemCarbonFootprintInformationDistance: 'Distance',
	LayoutItemCarbonFootprintInformationTravelTime: 'Travel time',
	LayoutItemCarbonFootprintInformationCO2: 'CO2 emissions',
	CarbonFootprintFrom: 'From',
	CarbonFootprintTo: 'To',
	CarbonFootprintUsers: 'Users',

	AvailabilityModelCustomer: 'Customer',
	AvailabilitiesPopinModelTitle: 'Availabilities {0}',
	AvailabilitiesPopinObjectTitle: 'Availabilities of {0}',
	AvailabilitiesSlots: 'Slots of availability',
	AvailabilitiesSlotsProposedByVisit: 'Slots of availability proposed by visit done',
	AvailabilitiesMorning: 'Morning',
	AvailabilitiesAfternoon: 'Afternoon',
	AvailabilitiesPopinErrorMessage: 'Invalid availabilities',
	AvailabilitiesSlotsProposedByVisitReplaceMessage: 'You have just made a visit outside the theoretical access hours. Would you like to update the access hours?',

	NPSSendingErrorMessage: 'An error occured while sending. Try again later.',
	NPSRequiredField: 'Required field',
	NPSScoreLabel: 'How likely are you to recommend Nomadia Sales ?',
	NPSCommentLabel: 'Why would you recommend us ?',
	NPSCanBePublicTitle: 'Do you agree ?',
	NPSCanBePublicDescription: 'Your comment can be published, anonymously, on our digital communication media',
	NPSCanBePublicLabel: 'I do not want my comment to be made public',
	NPSPostponeButtonLabel: 'Later',
	NPSSendButtonLabel: 'Submit',
	
	CGUError: 'An error occured while sending. Try again later.',
	CGURead1: 'To continue, please accept ',
	CGURead2: 'the terms and conditions of use',
	CGUAccept: 'I have read and accepted the terms and conditions of use',
	CGUValidate: 'Continue',
	CGULink: 'https://www.nomadia-group.com/en/general-terms-and-conditions-of-use/',

	// Gestion des moyens
	LayoutItemMeanGrid: 'Means grid',
	LayoutItemMeanGridFailedToLoad: 'Could not load means',
	LayoutItemMeanGridFailedToSave: 'Failed to save',
	LayoutItemMeanGridFilters: 'Means filter',
	LayoutItemMeanGridMaximize: 'Maximize means grid',
	LayoutItemMeanForm: 'Mean form',
	LayoutItemMeanFormMaximize: 'Maximize mean form',
	LayoutItemMeanFormFailedToLoad: 'Could not load mean',

	MeanGridCreate: 'Add mean',
	MeanGridCopy: 'Duplicate mean',
	MeanGridDelete: 'Delete mean',
	MeanGridDeleteConfirmation: 'Do you really want to delete the selected mean?',
	MeanNewLabel: 'New mean',
	MeanCopyOfLabel: 'Copy of {0}',
	MeanId: 'Id',
	MeanCode: 'Code',
	MeanCaption: 'Caption',
	MeanAvailabilityStartDate: 'Start date',
	MeanAvailabilityEndDate: 'End date',
	MeanOffer: 'Offer',
	MeanComments: 'Comment',
	MeanUnit: 'Unit',
	MeanActive: 'Active',

	MeanQuotaAllocatedQuantiy: 'Quota',
	MeanQuotaUsedQuantity: 'Used',
	MeanQuotaDispatchedQuantity: 'Allocated',

	LayoutItemMeanQuotaTree: 'Quotas',
	LayoutItemMeanQuotaTreeMaximize: 'Maximize quota tree',
	LayoutItemMeanQuotaTreeResetButtonLabel: 'Reset',
	LayoutItemMeanQuotaTreeResetSpreadLabel: 'Dispatch',
	LayoutItemMeanQuotaTreeFailedToLoad: 'Could not load quotas',
	LayoutItemMeanQuotaTreeFailedToSave: 'Failed to save',
	LayoutItemMeanQuotaTreeAllocatedQuantityMissing: 'Allocated quantity ({1}) on sector "{0}" is less than children allocated quantity ({2})',
	LayoutItemMeanQuotaTreeUsedQuantityTooHighErrorMessage: 'Used quantity ({1}) on sector "{0}" is greater than allocated quantity ({2})',

	MeanActivityMeanId: 'Mean ID',
	MeanActivityMeanCode: 'Mean coden',
	MeanActivityMeanCaption: 'Mean caption',
	MeanActivitySectorId: 'Sector',
	MeanActivityAction: 'Action',
	MeanActivityActionAllocation: 'Allocation',
	MeanActivityActionUse: 'Usage',
	MeanActivityValue: 'Value',
	MeanActivityCustomerId: 'Customer ID',
	MeanActivityCustomerCode: 'Customer code',
	MeanActivityCustomerEan: 'Customer EAN',
	MeanActivityCustomerCaption: 'Customer caption',
	MeanActivityOfferId: 'Offer ID',
	MeanActivityOfferCode: 'Offer code',
	MeanActivityOfferCaption: 'Offer caption',
	MeanActivityVisitId: 'Visit ID',
	MeanActivityVisitCode: 'Visit code',
	MeanActivityVisitDate: 'Visit date',
	MeanActivityOrderId: 'Order ID',
	MeanActivityOrderCode: 'Order code',
	MeanActivityOrderDate: 'Order date',
	MeanActivityDate: 'Input date',
	MeanActivityUser: 'User',

	LayoutItemMeanActivityGrid: 'Mean activities',
	LayoutItemMeanActivityGridFilters: 'Mean activities filter',
	LayoutItemMeanActivityGridMaximize: 'Maximize mean activities',
	LayoutItemMeanActivityGridFailedToLoad: 'Could not load mean activities'
});

})();